const config = [
  // 系统考核 已完成
  {
    permissionId: 73,
    name: '系统考核',
    relativeId: '120',
    id: '120',
    showtitle: true,
    isHide: false,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/examine/autoTaskList?status=6',
    tableColumnsName: 'xtkh', // 当前页面 table的取值
    filters: {
      left: [{
        id: '120-s-1',
        parentId: '120',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌名称：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      }, {
        id: '120-s-10',
        parentId: '120',
        type: 'input',
        className: 'w120',
        label: '任务编码：',
        key: 'workId',
        value: null,
        placeholder: '全部'
      }, {
        id: '120-s-12',
        parentId: '120',
        type: 'input',
        className: 'w120',
        label: '站点编号：',
        key: 'siteId',
        value: null,
        placeholder: '全部'
      }, {
        id: '120-s-13',
        parentId: '120',
        type: 'input',
        className: 'w120',
        label: '车辆编号：',
        key: 'bikeId',
        value: undefined,
        placeholder: '全部',
      }, {
        id: '120-s-2',
        parentId: '120',
        type: 'select',
        className: 'w120',
        options: [{
          key: null,
          value: '全部'
        }, {
          key: 100,
          value: '重点区域偏多调度'
        }, {
          key: 150,
          value: '普通区域偏多调度'
        }, {
          key: 200,
          value: '站外还车调度'
        }, {
          key: 250,
          value: '非法车辆调度'
        }],
        label: '任务类型：',
        key: 'mold',
        value: null,
        placeholder: '全部'
      }, {
        id: '120-s-4',
        parentId: '120',
        type: 'select',
        className: 'w120',
        options: [{
          key: null,
          value: '全部'
        }, {
          key: 0,
          value: '未响应'
        }, {
          key: 50,
          value: '未响应(超时)'
        }, {
          key: 100,
          value: '已响应(超时)'
        }, {
          key: 200,
          value: '已响应(及时)'
        }],
        label: '响应状态：',
        key: 'respondStatus',
        value: null,
        placeholder: '全部'
      }, {
        id: '120-s-3',
        parentId: '120',
        type: 'select',
        className: 'w120',
        options: [{
          key: null,
          value: '全部'
        }, {
          key: 0,
          value: '待完成'
        }, {
          key: 100,
          value: '未完成'
        }, {
          key: 200,
          value: '已完成'
        }, {
          key: 250,
          value: '异常终止'
        }],
        label: '完成状态：',
        key: 'completeStatus',
        value: null,
        placeholder: '全部'
      },{
        id: '120-s-5',
        parentId: '120',
        type: 'dataRange',
        label: '创建时间：',
        start: new Date().setDate(new Date().getDate() - 2),
        end: new Date(),
        key: 'time',
        value: undefined,
        placeholder: undefined
      }, {
        id: '120-s-7',
        parentId: '120',
        type: 'dataTimeRange',
        label: '完成时间：',
        start: undefined,
        end: undefined,
        key: 'completeTime',
        value: undefined,
        placeholder: undefined
      }, {
        id: '120-s-6',
        parentId: '120',
        type: 'dataTimeRange',
        label: '超时时间：',
        start: undefined,
        end: undefined,
        key: 'respondTime',
        value: undefined,
        placeholder: undefined
      }, {
        id: '120-s-8',
        parentId: '120',
        type: 'button',
        label: '查询',
        typeStyle: 'primary',
        fn: 'search'
      },{
        id: '120-s-9',
        parentId: '120',
        type: 'button',
        label: '重置',
        typeStyle: '',
        fn: 'reset'
      },{
        id: '120-s-11',
        parentId: '120',
        type: 'button',
        permissionId: 73,
        label: '导出',
        dialogWidth: '60%',
        fn: 'export'
      }
      ]
    }
  },
  // 人工考核 未认领
  {
    permissionId: 73,
    name: '人工考核',
    id: '110',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/examine/taskList?status=0',
    tableColumnsName: 'rgkh', // 当前页面 table的取值
    filters: {
      left: [{
        id: '110-s-1',
        parentId: '110',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '110-s-2',
          parentId: '110',
          type: 'input',
          className: 'w120',
          label: '类型：',
          key: 'title',
          value: undefined,
          placeholder: '请输入'
        },
        {
          id: '110-s-3',
          parentId: '110',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '110-s-4',
          parentId: '110',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '110-s-5',
          parentId: '110',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ]
    },
    children: [{
      parentId: '110',
      name: '未认领',
      id: '110-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '110' // 会跳转到对应到关联页面
    }, {
      parentId: '110',
      name: '未整改',
      id: '110-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '111' // 会跳转到对应到关联页面
    }, {
      parentId: '110',
      name: '未核验',
      id: '110-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '112' // 会跳转到对应到关联页面
    }, {
      parentId: '110',
      name: '已完成',
      id: '110-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '113' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '110-tb-1',
      parentId: '110',
      type: 'button',
      label: '查看',
      api: '/api/examine/taskInfo',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          label: '举报位置',
          key: 'address',
          component: 'text',
          value: ''
        }, {
          label: '举报品牌',
          key: 'brandName',
          component: 'text'
        }, {
          label: '违规类型',
          key: 'examineInfo',
          component: 'text',
          filters: 'filterRuleConfig'
        }, {
          label: '举报状态',
          key: 'status',
          component: 'text',
          filters: 'filterStatus4'
        }, {
          label: '提交人',
          key: 'reportName',
          component: 'text',
          value: ''
        }, {
          className: 'mb24',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }, {
          label: '具体描述',
          key: 'memo',
          component: 'text',
          value: ''
        }, {
          label: '照片',
          key: 'pictures',
          component: 'image',
          value: ''
        }
      ],
      isShowCancelBtn: false,
      isShowSureBtn: false
    },
      {
        permissionId: 74,
        id: '110-tb-2',
        parentId: '110',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wgjbDel',
        bLine: true,
        hide: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '110-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该违规举报？',
          filters: undefined
        }]
      }
    ]
  },
  // 人工考核 未整改
  {
    permissionId: 73,
    name: '人工考核',
    id: '111',
    relativeId: '110',
    showtitle: true,
    isHide: true,
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/examine/taskList?status=1',
    tableColumnsName: 'rgkh', // 当前页面 table的取值
    filters: {
      left: [{
        id: '111-s-1',
        parentId: '111',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '111-s-2',
          parentId: '111',
          type: 'input',
          className: 'w120',
          label: '类型：',
          key: 'title',
          value: undefined,
          placeholder: '请输入'
        },
        {
          id: '111-s-3',
          parentId: '111',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '111-s-4',
          parentId: '111',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '111-s-5',
          parentId: '111',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ]
    },
    children: [{
      parentId: '111',
      name: '未认领',
      id: '111-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '110' // 会跳转到对应到关联页面
    }, {
      parentId: '111',
      name: '未整改',
      id: '111-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '111' // 会跳转到对应到关联页面
    }, {
      parentId: '111',
      name: '未核验',
      id: '111-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '112' // 会跳转到对应到关联页面
    }, {
      parentId: '111',
      name: '已完成',
      id: '111-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '113' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '111-tb-1',
      parentId: '111',
      type: 'button',
      label: '查看',
      fn: 'wgjbShowDetail',
      api: '/api/examine/taskInfo',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          label: '举报位置',
          key: 'address',
          component: 'text',
          filters: undefined
        }, {
          label: '举报品牌',
          key: 'brandName',
          component: 'text'
        }, {
          label: '违规类型',
          key: 'examineInfo',
          component: 'text',
          filters: 'filterRuleConfig'
        }, {
          label: '举报状态',
          key: 'status',
          component: 'text',
          filters: 'filterStatus4'
        }, {
          label: '转派状态',
          key: 'redeployStatus',
          component: 'text',
          filters: 'filterStatus3'
        }, {
          label: '提交人',
          key: 'reportName',
          component: 'text',
          filters: undefined
        }, {
          className: 'mb24',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          filters: 'dateFormat'
        }, {
          label: '具体描述',
          key: 'memo',
          component: 'text',
          filters: undefined
        }, {
          className: 'mb24',
          label: '照片',
          key: 'pictures',
          component: 'image',
          filters: undefined
        }, {
          label: '认领人',
          key: 'claimUserName',
          component: 'text',
          filters: undefined
        }, {
          className: 'mb24',
          label: '认领时间',
          key: 'claimTime',
          component: 'text',
          filters: 'dateFormat'
        }, {
          label: '照片',
          key: 'miAccuseLogVo',
          component: 'text',
          filters: undefined
        }
      ],
      isShowCancelBtn: false,
      isShowSureBtn: false
    }]
  },
  // 人工考核 未核验
  {
    permissionId: 73,
    name: '人工考核',
    isHide: true,
    showtitle: true,
    relativeId: '110',
    id: '112',
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/examine/taskList?status=2',
    tableColumnsName: 'rgkh', // 当前页面 table的取值
    filters: {
      left: [{
        id: '112-s-1',
        parentId: '112',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '112-s-2',
          parentId: '112',
          type: 'input',
          className: 'w120',
          label: '类型：',
          key: 'title',
          value: undefined,
          placeholder: '请输入'
        },
        {
          id: '112-s-6',
          parentId: '112',
          type: 'dataRange',
          label: '整改时间：',
          start: undefined,
          end: undefined,
          key: 'diff',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '112-s-3',
          parentId: '112',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '112-s-4',
          parentId: '112',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '112-s-5',
          parentId: '112',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ]
    },
    children: [{
      parentId: '112',
      name: '未认领',
      id: '112-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '110' // 会跳转到对应到关联页面
    }, {
      parentId: '112',
      name: '未整改',
      id: '112-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '111' // 会跳转到对应到关联页面
    }, {
      parentId: '112',
      name: '未核验',
      id: '112-st-3',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '112' // 会跳转到对应到关联页面
    }, {
      parentId: '112',
      name: '已完成',
      id: '112-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '113' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '112-tb-1',
      parentId: '112',
      type: 'button',
      label: '查看',
      fn: 'wgjbShowDetail',
      api: '/api/examine/taskInfo',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [{
        label: '举报位置',
        key: 'address',
        component: 'text',
        filters: undefined
      }, {
        label: '举报品牌',
        key: 'brandName',
        component: 'text'
      }, {
        label: '违规类型',
        key: 'examineInfo',
        component: 'text',
        filters: 'filterRuleConfig'
      }, {
        label: '举报状态',
        key: 'status',
        component: 'text',
        filters: 'filterStatus4'
      }, {
        label: '转派状态',
        key: 'redeployStatus',
        component: 'text',
        filters: 'filterStatus3'
      }, {
        label: '提交人',
        key: 'reportName',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '创建时间',
        key: 'createTime',
        component: 'text',
        filters: 'dateFormat'
      }, {
        label: '具体描述',
        key: 'memo',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '照片',
        key: 'pictures',
        component: 'image',
        filters: undefined
      }, {
        label: '认领人',
        key: 'claimUserName',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '认领时间',
        key: 'claimTime',
        component: 'text',
        filters: 'dateFormat'
      }, {
        label: '照片',
        key: 'miAccuseLogVo',
        component: 'text',
        filters: undefined
      }],
      isShowCancelBtn: false,
      isShowSureBtn: false
    }]
  },
  // 人工考核 已完成
  {
    permissionId: 73,
    name: '人工考核',
    relativeId: '110',
    id: '113',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/examine/taskList?status=3',
    tableColumnsName: 'rgkh', // 当前页面 table的取值
    filters: {
      left: [{
        id: '113-s-1',
        parentId: '113',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '113-s-2',
          parentId: '113',
          type: 'input',
          className: 'w120',
          label: '类型：',
          key: 'title',
          value: undefined,
          placeholder: '请输入'
        },
        {
          id: '113-s-6',
          parentId: '113',
          type: 'dataRange',
          label: '整改时间：',
          start: undefined,
          end: undefined,
          key: 'diff',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '113-s-3',
          parentId: '113',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '113-s-4',
          parentId: '113',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '113-s-5',
          parentId: '113',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ]
    },
    children: [{
      parentId: '113',
      name: '未认领',
      id: '113-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '110' // 会跳转到对应到关联页面
    }, {
      parentId: '113',
      name: '未整改',
      id: '113-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '111' // 会跳转到对应到关联页面
    }, {
      parentId: '113',
      name: '未核验',
      id: '113-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '112' // 会跳转到对应到关联页面
    }, {
      parentId: '113',
      name: '已完成',
      id: '113-st-4',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '113' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '113-tb-1',
      parentId: '113',
      type: 'button',
      label: '查看',
      fn: 'wgjbShowDetail',
      api: '/api/examine/taskInfo',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [{
        label: '举报位置',
        key: 'address',
        component: 'text',
        filters: undefined
      }, {
        label: '举报品牌',
        key: 'brandName',
        component: 'text'
      }, {
        label: '违规类型',
        key: 'examineInfo',
        component: 'text',
        filters: 'filterRuleConfig'
      }, {
        label: '举报状态',
        key: 'status',
        component: 'text',
        filters: 'filterStatus4'
      }, {
        label: '转派状态',
        key: 'redeployStatus',
        component: 'text',
        filters: 'filterStatus3'
      }, {
        label: '提交人',
        key: 'reportName',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '创建时间',
        key: 'createTime',
        component: 'text',
        filters: 'dateFormat'
      }, {
        label: '具体描述',
        key: 'memo',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '照片',
        key: 'pictures',
        component: 'image',
        filters: undefined
      }, {
        label: '认领人',
        key: 'claimUserName',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '认领时间',
        key: 'claimTime',
        component: 'text',
        filters: 'dateFormat'
      }, {
        label: '照片',
        key: 'miAccuseLogVo',
        component: 'text',
        filters: undefined
      }],
      isShowCancelBtn: false,
      isShowSureBtn: false
    }]
  },
  // 日常举报 未认领
  {
    permissionId: 73,
    name: '日常举报',
    id: '100',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/getViolationHandlingList?status=0',
    tableColumnsName: 'wgcl', // 当前页面 table的取值
    titleRight: [{
      permissionId: 73,
      id: '100-c-3',
      parentId: '100',
      type: 'button',
      label: '违规举报',
      className: '',
      fn: 'addReport',
      title: '违规举报',
      dialogWidth: '60%',
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '提交',
      api: '/api/miApp/addNotice',
      children: [{
        id: '100-c-3-1',
        className: '',
        parentId: '100-c-3',
        label: '违规位置：',
        key: 'address',
        component: 'input',
        value: undefined
      }, {
        id: '100-c-3-2',
        className: '',
        parentId: '100-c-3',
        label: '选择品牌：',
        key: 'brandId',
        component: 'radio',
        optionskey: 'brands',
        value: undefined
      }, {
        id: '100-c-3-3',
        className: '',
        parentId: '100-c-3',
        label: '违规类型：',
        key: 'accuseTypes',
        component: 'radio',
        optionskey: 'replyTypeList',
        value: undefined
      }, {
        id: '100-c-3-4',
        className: '',
        parentId: '100-c-3',
        label: '上传照片：',
        key: 'pictures',
        component: 'upload',
        value: undefined
      }, {
        id: '100-c-3-5',
        className: '',
        parentId: '100-c-3',
        label: '具体描述：',
        key: 'memo',
        component: 'textarea',
        value: undefined,
        rows: '3'
      }]
    }, {
      id: '100-c-1',
      parentId: '100',
      type: 'button',
      label: '品牌报表',
      typeStyle: '',
      fn: 'illegalOperation',
      relativeId: '104' // 会跳转到对应到关联页面
    },
      {
        id: '100-c-2',
        parentId: '100',
        type: 'button',
        label: '违规类型设置',
        typeStyle: 'primary',
        fn: 'illegalOperation',
        relativeId: '700' // 会跳转到对应到关联页面
      }
    ],
    filters: {
      left: [{
        id: '100-s-1',
        parentId: '100',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '100-s-2',
          parentId: '100',
          type: 'select',
          className: 'w120',
          optionskey: 'replyTypeList',
          options: undefined,
          label: '类型：',
          key: 'type',
          value: undefined,
          placeholder: '全部'
        },
        {
          id: '100-s-3',
          parentId: '100',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '100-s-4',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '100-s-5',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '100-b-1',
          parentId: '100',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          typeStyle: '',
          className: '',
          fn: 'numsDetele',
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '100-b-1-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除该违规举报？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '100',
      name: '未认领',
      id: '100-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '100' // 会跳转到对应到关联页面
    }, {
      parentId: '100',
      name: '未整改',
      id: '100-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '101' // 会跳转到对应到关联页面
    }, {
      parentId: '100',
      name: '未核验',
      id: '100-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '102' // 会跳转到对应到关联页面
    }, {
      parentId: '100',
      name: '已完成',
      id: '100-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '103' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '100-tb-1',
      parentId: '100',
      type: 'button',
      label: '查看',
      api: '/api/miApp/getTaskDetail',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [{
        label: '举报位置',
        key: 'address',
        component: 'text',
        value: ''
      }, {
        label: '举报品牌',
        key: 'brandIds',
        component: 'text',
        value: '',
        filters: 'filterBrandName'
      }, {
        label: '违规类型',
        key: 'accuseTypes',
        component: 'text',
        value: '',
        filters: 'filterAccuseTypes'
      }, {
        label: '举报状态',
        key: 'status',
        component: 'text',
        value: '',
        filters: 'filterStatus'
      }, {
        label: '提交人',
        key: 'submitName',
        component: 'text',
        value: ''
      }, {
        label: '工作单位',
        key: 'submitWorkOrgan',
        component: 'text',
        value: ''
      }, {
        className: 'mb24',
        label: '创建时间',
        key: 'createTime',
        component: 'text',
        value: '',
        filters: 'dateFormat'
      }, {
        label: '具体描述',
        key: 'memo',
        component: 'text',
        value: ''
      }, {
        label: '照片',
        key: 'pictures',
        component: 'image',
        value: ''
      }],
      isShowCancelBtn: false,
      isShowSureBtn: false
    },
      {
        permissionId: 74,
        id: '100-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wgjbDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '100-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该违规举报？',
          filters: undefined
        }]
      }
    ]
  },
  // 日常举报 未整改
  {
    permissionId: 73,
    name: '日常举报',
    id: '101',
    relativeId: '100',
    showtitle: true,
    isHide: true,
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/getViolationHandlingList?status=1',
    tableColumnsName: 'wgcl', // 当前页面 table的取值
    titleRight: [{
      id: '101-c-1',
      parentId: '100',
      type: 'button',
      label: '品牌报表',
      typeStyle: '',
      fn: 'illegalOperation',
      relativeId: '104' // 会跳转到对应到关联页面
    },
      {
        id: '101-c-2',
        parentId: '100',
        type: 'button',
        label: '违规类型设置',
        typeStyle: 'primary',
        fn: 'illegalOperation',
        relativeId: '700' // 会跳转到对应到关联页面
      }
    ],
    filters: {
      left: [{
        id: '101-s-1',
        parentId: '101',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '101-s-2',
          parentId: '101',
          type: 'select',
          className: 'w120',
          optionskey: 'replyTypeList',
          options: undefined,
          label: '类型：',
          key: 'type',
          value: undefined,
          placeholder: '全部'
        },
        {
          id: '101-s-3',
          parentId: '101',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '101-s-4',
          parentId: '101',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '101-s-5',
          parentId: '101',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '101-b-1',
          parentId: '101',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          typeStyle: '',
          className: '',
          fn: 'numsDetele',
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '101-b-1-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除该违规举报？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '101',
      name: '未认领',
      id: '101-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '100' // 会跳转到对应到关联页面
    }, {
      parentId: '101',
      name: '未整改',
      id: '101-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '101' // 会跳转到对应到关联页面
    }, {
      parentId: '101',
      name: '未核验',
      id: '101-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '102' // 会跳转到对应到关联页面
    }, {
      parentId: '101',
      name: '已完成',
      id: '101-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '103' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '101-tb-1',
      parentId: '101',
      type: 'button',
      label: '查看',
      fn: 'wgjbShowDetail',
      api: '/api/miApp/getTaskDetail',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [{
        label: '举报位置',
        key: 'address',
        component: 'text',
        filters: undefined
      }, {
        label: '举报品牌',
        key: 'brandIds',
        component: 'text',
        filters: 'filterBrandName'
      }, {
        label: '违规类型',
        key: 'accuseTypes',
        component: 'text',
        filters: 'filterAccuseTypes'
      }, {
        label: '举报状态',
        key: 'status',
        component: 'text',
        filters: 'filterStatus'
      }, {
        label: '转派状态',
        key: 'redeployStatus',
        component: 'text',
        filters: 'filterStatus3'
      }, {
        label: '提交人',
        key: 'submitName',
        component: 'text',
        filters: undefined
      }, {
        label: '工作单位',
        key: 'submitWorkOrgan',
        component: 'text'
      }, {
        className: 'mb24',
        label: '创建时间',
        key: 'createTime',
        component: 'text',
        filters: 'dateFormat'
      }, {
        label: '具体描述',
        key: 'memo',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '照片',
        key: 'pictures',
        component: 'image',
        filters: undefined
      }, {
        label: '认领人',
        key: 'claimUserName',
        component: 'text',
        filters: undefined
      }, {
        className: 'mb24',
        label: '认领时间',
        key: 'claimTime',
        component: 'text',
        filters: 'dateFormat'
      }, {
        label: '照片',
        key: 'miAccuseLogVo',
        component: 'text',
        filters: undefined
      }],
      isShowCancelBtn: false,
      isShowSureBtn: false
    },
      {
        permissionId: 74,
        id: '101-tb-2',
        parentId: '101',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wgjbDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '101-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该违规举报？',
          filters: undefined
        }]
      }
    ]
  },
  // 日常举报 未核验
  {
    permissionId: 73,
    name: '日常举报',
    isHide: true,
    showtitle: true,
    relativeId: '100',
    id: '102',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/getViolationHandlingList?status=2',
    tableColumnsName: 'wgcl', // 当前页面 table的取值
    titleRight: [{
      id: '102-c-1',
      parentId: '102',
      type: 'button',
      label: '品牌报表',
      typeStyle: '',
      fn: 'illegalOperation',
      relativeId: '104' // 会跳转到对应到关联页面
    },
      {
        id: '102-c-2',
        parentId: '102',
        type: 'button',
        label: '违规类型设置',
        typeStyle: 'primary',
        fn: 'illegalOperation',
        relativeId: '700' // 会跳转到对应到关联页面
      }
    ],
    filters: {
      left: [{
        id: '102-s-1',
        parentId: '102',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '102-s-2',
          parentId: '102',
          type: 'select',
          className: 'w120',
          optionskey: 'replyTypeList',
          options: undefined,
          label: '类型：',
          key: 'type',
          value: undefined,
          placeholder: '全部'
        },
        {
          id: '102-s-6',
          parentId: '102',
          type: 'dataRange',
          label: '整改时间：',
          start: undefined,
          end: undefined,
          key: 'diff',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '102-s-3',
          parentId: '102',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '102-s-4',
          parentId: '102',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '102-s-5',
          parentId: '102',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '102-b-1',
          parentId: '102',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          typeStyle: '',
          className: '',
          fn: 'numsDetele',
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '102-b-1-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除该违规举报？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '102',
      name: '未认领',
      id: '102-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '100' // 会跳转到对应到关联页面
    }, {
      parentId: '102',
      name: '未整改',
      id: '102-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '101' // 会跳转到对应到关联页面
    }, {
      parentId: '102',
      name: '未核验',
      id: '102-st-3',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '102' // 会跳转到对应到关联页面
    }, {
      parentId: '102',
      name: '已完成',
      id: '102-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '103' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '102-tb-1',
      parentId: '102',
      type: 'button',
      label: '查看',
      fn: 'wgjbShowDetail',
      api: '/api/miApp/getTaskDetail',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          label: '举报位置',
          key: 'address',
          component: 'text'
        }, {
          label: '举报品牌',
          key: 'brandIds',
          component: 'text',
          filters: 'filterBrandName'
        }, {
          label: '违规类型',
          key: 'accuseTypes',
          component: 'text',
          filters: 'filterAccuseTypes'
        }, {
          label: '举报状态',
          key: 'status',
          component: 'text',
          filters: 'filterStatus'
        }, {
          label: '转派状态',
          key: 'redeployStatus',
          component: 'text',
          filters: 'filterStatus3'
        }, {
          label: '提交人',
          key: 'submitName',
          component: 'text',
          filters: undefined
        }, {
          label: '工作单位',
          key: 'submitWorkOrgan',
          component: 'text'
        }, {
          className: 'mb24',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          filters: 'dateFormat'
        }, {
          label: '具体描述',
          key: 'memo',
          component: 'text',
          filters: undefined
        }, {
          label: '照片',
          key: 'pictures',
          component: 'image',
          filters: undefined
        }, {
          label: '认领人',
          key: 'claimUserName',
          component: 'text',
          filters: undefined
        }, {
          className: 'mb24',
          label: '认领时间',
          key: 'claimTime',
          component: 'text',
          filters: 'dateFormat'
        }, {
          label: '照片',
          key: 'miAccuseLogVo',
          component: 'text',
          filters: undefined
        }
      ],
      isShowCancelBtn: false,
      isShowSureBtn: false
    },
      {
        permissionId: 74,
        id: '102-tb-2',
        parentId: '102',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wgjbDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '102-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该违规举报？',
          filters: undefined
        }]
      }
    ]
  },
  // 日常举报 已完成
  {
    permissionId: 73,
    name: '日常举报',
    relativeId: '100',
    id: '103',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/getViolationHandlingList?status=3',
    tableColumnsName: 'wgcl', // 当前页面 table的取值
    titleRight: [{
      id: '103-c-1',
      parentId: '103',
      type: 'button',
      label: '品牌报表',
      typeStyle: '',
      fn: 'illegalOperation',
      relativeId: '104' // 会跳转到对应到关联页面
    },
      {
        id: '103-c-2',
        parentId: '103',
        type: 'button',
        label: '违规类型设置',
        typeStyle: 'primary',
        fn: 'illegalOperation',
        relativeId: '700' // 会跳转到对应到关联页面
      }
    ],
    filters: {
      left: [{
        id: '103-s-1',
        parentId: '103',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '103-s-2',
          parentId: '103',
          type: 'select',
          className: 'w120',
          optionskey: 'replyTypeList',
          options: undefined,
          label: '类型：',
          key: 'type',
          value: undefined,
          placeholder: '全部'
        },
        {
          id: '103-s-6',
          parentId: '103',
          type: 'dataRange',
          label: '整改时间：',
          start: undefined,
          end: undefined,
          key: 'diff',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '103-s-3',
          parentId: '103',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '103-s-4',
          parentId: '103',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '103-s-5',
          parentId: '103',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '103-b-1',
          parentId: '103',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          typeStyle: '',
          className: '',
          fn: 'numsDetele',
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '103-b-1-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除该违规举报？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '103',
      name: '未认领',
      id: '103-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '100' // 会跳转到对应到关联页面
    }, {
      parentId: '103',
      name: '未整改',
      id: '103-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '101' // 会跳转到对应到关联页面
    }, {
      parentId: '103',
      name: '未核验',
      id: '103-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '102' // 会跳转到对应到关联页面
    }, {
      parentId: '103',
      name: '已完成',
      id: '103-st-4',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '103' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 75,
      id: '103-tb-1',
      parentId: '103',
      type: 'button',
      label: '查看',
      fn: 'wgjbShowDetail',
      api: '/api/miApp/getTaskDetail',
      bLine: false,
      title: '违规详情',
      dialogWidth: '45%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          label: '举报位置',
          key: 'address',
          component: 'text'
        }, {
          label: '举报品牌',
          key: 'brandIds',
          component: 'text',
          filters: 'filterBrandName'
        }, {
          label: '违规类型',
          key: 'accuseTypes',
          component: 'text',
          filters: 'filterAccuseTypes'
        }, {
          label: '举报状态',
          key: 'status',
          component: 'text',
          filters: 'filterStatus'
        }, {
          label: '转派状态',
          key: 'redeployStatus',
          component: 'text',
          filters: 'filterStatus3'
        }, {
          label: '提交人',
          key: 'submitName',
          component: 'text',
          filters: undefined
        }, {
          label: '工作单位',
          key: 'submitWorkOrgan',
          component: 'text'
        }, {
          className: 'mb24',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          filters: 'dateFormat'
        }, {
          label: '具体描述',
          key: 'memo',
          component: 'text',
          filters: undefined
        }, {
          label: '照片',
          key: 'pictures',
          component: 'image',
          filters: undefined
        }, {
          label: '认领人',
          key: 'claimUserName',
          component: 'text',
          filters: undefined
        }, {
          className: 'mb24',
          label: '认领时间',
          key: 'claimTime',
          component: 'text',
          filters: 'dateFormat'
        }, {
          label: '照片',
          key: 'miAccuseLogVo',
          component: 'text',
          filters: undefined
        }
      ],
      isShowCancelBtn: false,
      isShowSureBtn: false
    },
      {
        permissionId: 74,
        id: '103-tb-2',
        parentId: '103',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wgjbDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '103-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该违规举报？',
          filters: undefined
        }]
      }
    ]
  },
  // 违规类型设置 1
  {
    permissionId: 97,
    name: '违规类型设置',
    isHide: true,
    relativeId: '100',
    id: '700',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: false, // 当前表格是否多选
    bPagination: false,
    api: '/api/miApp/getReplyTypeList',
    tableColumnsName: 'wglxsz', // 当前页面 table的取值
    filters: {
      left: [{
        id: '700-s-1',
        parentId: '700',
        type: 'statictext',
        value: '违规类型设置'
      }],
      right: [{
        permissionId: 76,
        id: '700-b-1',
        parentId: '700',
        type: 'button',
        label: '添加类型',
        typeStyle: 'primary',
        className: '',
        fn: 'addWGType',
        api: '/api/miApp/addReplyType',
        title: '添加类型',
        dialogWidth: '80%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        children: [{
          id: '700-b-1-1',
          component: 'input',
          className: 'w100p',
          label: '类型名称：',
          key: 'title',
          value: undefined,
          placeholder: '请输入'
        }, {
          id: '700-b-1-2',
          component: 'input',
          label: '排序：',
          key: 'sort',
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '700-b-1-3',
          component: 'areaArea',
          label: '适用范围：',
          key: 'area',
          value: undefined,
          placeholder: '地区'
        }]
      }]
    },
    children: undefined,
    tableButtons: [{
      permissionId: 77,
      id: '700-tb-1',
      parentId: '100',
      type: 'button',
      api: '/api/miApp/editReplyType',
      title: '编辑类型',
      label: '编辑',
      fn: 'editWGType',
      bLine: false,
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      dialogWidth: '80%',
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      children: [{
        id: '700-tb-1-1',
        component: 'input',
        className: 'w100p',
        label: '类型名称：',
        key: 'title',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '700-tb-1-2',
        component: 'input',
        label: '排序：',
        key: 'sort',
        value: undefined,
        placeholder: '请输入数字'
      }]
    },
      {
        permissionId: 78,
        id: '700-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'delWGType',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '700-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该违规类型？',
          filters: undefined
        }]
      }
    ]
  },
  // 品牌报表
  {
    permissionId: 97,
    name: '品牌报表',
    isHide: true,
    showtitle: true,
    relativeId: '100',
    id: '104',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: false, // 当前表格是否多选
    bPagination: false,
    api: '/api/miApp/getBrandReport',
    tableColumnsName: 'brandsList', // 当前页面 table的取值
    filters: {
      left: [{
        id: '104-s-1',
        parentId: '104',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '104-s-2',
          parentId: '104',
          type: 'dateselect',
          label: '时间：',
          key: 'time',
          dValue: new Date(),
          value: undefined,
          placeholder: '请选择日期',
        },
        {
          id: '104-s-3',
          parentId: '104',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '104-s-4',
          parentId: '104',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '104-s-5',
          parentId: '104',
          type: 'button',
          permissionId: 74,
          label: '导出',
          typeStyle: '',
          className: '',
          fn: ''
        }
      ]
    },
    children: [{
      parentId: '104',
      name: '举报',
      id: '104-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '104' // 会跳转到对应到关联页面
    }, {
      parentId: '104',
      name: '系统监测',
      id: '104-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '105' // 会跳转到对应到关联页面
    }]
  },
  // 品牌报表
  {
    permissionId: 97,
    name: '品牌报表',
    isHide: true,
    showtitle: true,
    relativeId: '104',
    id: '105',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: false, // 当前表格是否多选
    bPagination: false,
    api: '/api/miApp/getBrandReport',
    tableColumnsName: 'brandsList', // 当前页面 table的取值
    filters: {
      left: [{
        id: '104-s-1',
        parentId: '104',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      },
        {
          id: '104-s-2',
          parentId: '104',
          type: 'dateselect',
          label: '时间：',
          key: 'time',
          dValue: new Date(),
          value: undefined,
          placeholder: '请选择日期'
        },
        {
          id: '104-s-3',
          parentId: '104',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '104-s-4',
          parentId: '104',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '104-s-5',
          parentId: '104',
          type: 'button',
          permissionId: 74,
          label: '导出',
          typeStyle: '',
          className: '',
          fn: ''
        }
      ]
    },
    children: [{
      parentId: '104',
      name: '举报',
      id: '104-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '104' // 会跳转到对应到关联页面
    }, {
      parentId: '104',
      name: '系统监测',
      id: '104-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '105' // 会跳转到对应到关联页面
    }]
  },
  // 站点申请 - 审核
  {
    permissionId: 80,
    name: '站点申请',
    id: '200',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    pageSizes: [100, 200, 500],
    defaultPageSize: 100,
    total: 0,
    tableData: undefined,
    api: '/api/miApp/getCheckList',
    tableColumnsName: 'zdsq_sh', // 当前页面 table的取值
    initTranslate: true,
    filters: {
      left: [{
        id: '200-s-1',
        parentId: '200',
        type: 'select',
        className: 'w130',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '勘察组'
          },
          {
            key: 0,
            value: '普通用户'
          }
        ],
        label: '角色：',
        key: 'isInvestigate',
        value: undefined,
        placeholder: ''
      },
        {
          id: '200-s-2',
          parentId: '200',
          type: 'select',
          className: 'w130',
          options: [{
            key: undefined,
            value: '全部'
          },
            {
              key: 1,
              value: '待审核'
            },
            {
              key: 2,
              value: '已审核'
            }
          ],
          label: '状态：',
          key: 'status',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '200-s-3',
          parentId: '200',
          className: 'w130',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '1',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '申请人：',
          key: 'applyUserId', // 组件返回的key
          value: undefined,
          placeholder: undefined
        },
        {
          id: '200-s-4',
          className: 'w130',
          parentId: '200',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '2',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '审核人：',
          key: 'checkUserId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '200-s-5',
          parentId: '200',
          type: 'dataRange',
          label: '创建时间：',
          start: undefined,
          end: undefined,
          key: 'create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '200-s-6',
          parentId: '200',
          type: 'dataRange',
          label: '审核时间：',
          start: undefined,
          end: undefined,
          key: 'check',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '200-s-7',
          parentId: '200',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '200-s-8',
          parentId: '200',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '200-s-9',
          parentId: '200',
          type: 'button',
          label: '导出',
          permissionId: 80,
          fn: 'auditExport'
        }
      ],
      right: undefined
    },
    tableButtons: [{
      permissionId: 'show',
      sureBtnPermissionId: 86,
      cancelBtnPermissionId: 85,
      id: '200-tb-1',
      parentId: '200',
      type: 'button',
      label: '查看',
      initDetail: 'zdsq_sh_translate_data',
      fn: 'wgjbShowDetail',
      bLine: false,
      title: '站点申请详情',
      dialogWidth: '55%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '200-tb-1',
          label: '申请进度',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '进度条',
          key: 'address',
          component: 'steps',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '申请信息',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '位置',
          key: 'address',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '站点长度',
          key: 'length',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '具体描述',
          key: 'memo',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '申请状态',
          key: 'selfStatus',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '照片',
          key: 'showPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '申请人',
          key: 'realname',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '角色',
          key: 'isInvestigate',
          component: 'text',
          value: '',
          filters: 'getInvestigateName'
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '联系方式',
          key: 'phone',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '200-tb-1',
          label: '所属单位',
          key: 'workOrgan',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '200-tb-1',
          label: '画线照片',
          key: 'huaxianPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '200-tb-1',
          label: '安装照片',
          key: 'anzhuangPictures',
          component: 'image',
          value: '',
          filters: undefined
        }
      ],
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '拒绝',
      sureBtnText: '通过',
      sureRelation: 'hasRejectAndPass',
      sureBtnClickContent: {
        title: '温馨提示',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_pass', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_reject',
        showType: 'dialog-text',
        fnApi: '/api/miApp/auditApproved',
        children: [{
          className: '',
          parentId: '200-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定审核通过该站点申请？',
          filters: undefined
        }]
      },
      cancelBtnClickContent: {
        title: '拒绝理由',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_tow_fail_sure', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_tow_fail_fail',
        showType: 'dialog-form',
        api: '/api/miApp/auditReject',
        children: [{
          className: '',
          parentId: '200-tb-1-2',
          label: '',
          id: '200-tb-1-1',
          key: 'reply', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝理由'
        }]
      }
    },
      {
        permissionId: 87,
        id: '200-tb-2',
        parentId: '200',
        type: 'button',
        label: '撤回',
        bLine: true,
        relativeKey: 'hasReturn',
        relativeValue: '1',
        title: '撤回原因',
        fn: 'zdsq_sh_return',
        dialogWidth: '',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/adminWithdraw',
        children: [{
          className: '',
          parentId: '200-tb-2',
          label: '',
          id: '200-tb-2-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写撤回原因！'
        }]
      }
    ],
    children: [{
      parentId: '200',
      name: '审核',
      id: '200-st-1',
      active: true,
      cached: false,
      state: undefined
    }, {
      parentId: '200',
      name: '画线',
      id: '200-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1000' // 会跳转到对应到关联页面
    }, {
      parentId: '200',
      name: '安装',
      id: '200-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1100' // 会跳转到对应到关联页面
    }, {
      parentId: '200',
      name: '已拒绝',
      id: '200-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1200' // 会跳转到对应到关联页面
    }, {
      parentId: '200',
      name: '不可画线',
      id: '200-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1300' // 会跳转到对应到关联页面
    }]
  },
  // 站点申请 - 画线
  {
    permissionId: 83,
    name: '站点申请',
    isHide: true,
    relativeId: '200',
    id: '1000',
    showtitle: true,
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    pageSizes: [100, 200, 500],
    defaultPageSize: 100,
    total: 0,
    tableData: undefined,
    api: '/api/miApp/getDrawCheckList',
    tableColumnsName: 'zdsq_hx', // 当前页面 table的取值
    initTranslate: true,
    filters: {
      left: [{
        id: '1000-s-2',
        parentId: '1000',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '待画线'
          },
          {
            key: 2,
            value: '已画线'
          }
        ],
        label: '状态：',
        key: 'status',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '1000-s-4',
          className: 'w120',
          parentId: '1000',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '2',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '审核人：',
          key: 'applyUserId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1000-s-3',
          className: 'w120',
          parentId: '1000',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '3',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '画线人：',
          key: 'drawerId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1000-s-6',
          parentId: '1000',
          type: 'dataRange',
          label: '审核时间：',
          start: undefined,
          end: undefined,
          key: 'check',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1000-s-5',
          parentId: '1000',
          type: 'dataRange',
          label: '画线时间：',
          start: undefined,
          end: undefined,
          key: 'create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1000-s-7',
          parentId: '1000',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '1000-s-8',
          parentId: '1000',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '1000-s-9',
          parentId: '200',
          type: 'button',
          label: '导出',
          fn: 'lineExport'
        }
      ],
      right: undefined
    },
    tableButtons: [{
      id: '1000-tb-1',
      parentId: '1000',
      type: 'button',
      label: '查看',
      initDetail: 'zdsq_sh_translate_data',
      fn: 'wgjbShowDetail',
      bLine: false,
      title: '站点申请详情',
      dialogWidth: '55%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '1000-tb-1',
          label: '申请进度',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '进度条',
          key: 'address',
          component: 'steps',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '申请信息',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '位置',
          key: 'address',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '站点长度',
          key: 'length',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '具体描述',
          key: 'memo',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '申请状态',
          key: 'selfStatus',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '照片',
          key: 'showPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '申请人',
          key: 'realname',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '角色',
          key: 'isInvestigate',
          component: 'text',
          value: '',
          filters: 'getInvestigateName'
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '联系方式',
          key: 'phone',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1000-tb-1',
          label: '所属单位',
          key: 'workOrgan',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1000-tb-1',
          label: '画线照片',
          key: 'huaxianPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1000-tb-1',
          label: '安装照片',
          key: 'anzhuangPictures',
          component: 'image',
          value: '',
          filters: undefined
        }
      ],
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '拒绝',
      sureBtnText: '通过',
      sureRelation: 'hasRejectAndPass',
      sureBtnClickContent: {
        title: '温馨提示',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_pass', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_reject',
        showType: 'dialog-text',
        fnApi: '/api/miApp/auditApproved',
        children: [{
          className: '',
          parentId: '1000-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定审核通过该站点申请？',
          filters: undefined
        }]
      },
      cancelBtnClickContent: {
        title: '拒绝理由',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_tow_fail_sure', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_tow_fail_fail',
        showType: 'dialog-form',
        api: '/api/miApp/auditReject',
        children: [{
          className: '',
          parentId: '1000-tb-1-2',
          label: '',
          id: '1000-tb-1-1',
          key: 'reply', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝理由'
        }]
      }
    },
      {
        permissionId: 87,
        id: '1000-tb-2',
        parentId: '1000',
        type: 'button',
        label: '撤回',
        bLine: true,
        relativeKey: 'hasReturn',
        relativeValue: '1',
        title: '撤回原因',
        fn: 'zdsq_sh_return',
        dialogWidth: '',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/adminWithdraw',
        children: [{
          className: '',
          parentId: '1000-tb-2',
          label: '',
          id: '1000-tb-2-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写撤回原因！'
        }]
      }
    ],
    children: [{
      parentId: '1000',
      name: '审核',
      id: '1000-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '200' // 会跳转到对应到关联页面
    }, {
      parentId: '1000',
      name: '画线',
      id: '1000-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '1000' // 会跳转到对应到关联页面
    }, {
      parentId: '1000',
      name: '安装',
      id: '1000-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1100' // 会跳转到对应到关联页面
    }, {
      parentId: '1000',
      name: '已拒绝',
      id: '1000-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1200' // 会跳转到对应到关联页面
    }, {
      parentId: '1000',
      name: '不可画线',
      id: '1000-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1300' // 会跳转到对应到关联页面
    }]
  },
  // 站点申请 - 安装
  {
    permissionId: 84,
    name: '站点申请',
    isHide: true,
    showtitle: true,
    relativeId: '200',
    id: '1100',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    pageSizes: [100, 200, 500],
    defaultPageSize: 100,
    total: 0,
    tableData: undefined,
    api: '/api/miApp/getInstallCheckList',
    tableColumnsName: 'zdsq_az', // 当前页面 table的取值
    initTranslate: true,
    filters: {
      left: [{
        id: '1100-s-2',
        parentId: '1100',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '待安装'
          },
          {
            key: 2,
            value: '已安装'
          }
        ],
        label: '状态：',
        key: 'status',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '1100-s-3',
          className: 'w120',
          parentId: '1100',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '3',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '画线人：',
          key: 'drawerId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1100-s-4',
          className: 'w120',
          parentId: '1100',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '4',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '安装人：',
          key: 'installersId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1100-s-5',
          parentId: '1100',
          type: 'dataRange',
          label: '画线时间：',
          start: undefined,
          end: undefined,
          key: 'create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1100-s-6',
          parentId: '1100',
          type: 'dataRange',
          label: '安装时间：',
          start: undefined,
          end: undefined,
          key: 'install',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1100-s-7',
          parentId: '1100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '1100-s-8',
          parentId: '1100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '1100-s-9',
          parentId: '200',
          type: 'button',
          label: '导出',
          fn: 'installExport'
        }
      ],
      right: undefined
    },
    tableButtons: [{
      id: '1100-tb-1',
      parentId: '1100',
      type: 'button',
      label: '查看',
      initDetail: 'zdsq_sh_translate_data',
      fn: 'wgjbShowDetail',
      bLine: false,
      title: '站点申请详情',
      dialogWidth: '55%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '1100-tb-1',
          label: '申请进度',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '进度条',
          key: 'address',
          component: 'steps',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '申请信息',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '位置',
          key: 'address',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '站点长度',
          key: 'length',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '具体描述',
          key: 'memo',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '申请状态',
          key: 'selfStatus',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '照片',
          key: 'showPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '申请人',
          key: 'realname',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '角色',
          key: 'isInvestigate',
          component: 'text',
          value: '',
          filters: 'getInvestigateName'
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '联系方式',
          key: 'phone',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1100-tb-1',
          label: '所属单位',
          key: 'workOrgan',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1100-tb-1',
          label: '画线照片',
          key: 'huaxianPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1100-tb-1',
          label: '安装照片',
          key: 'anzhuangPictures',
          component: 'image',
          value: '',
          filters: undefined
        }
      ],
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '拒绝',
      sureBtnText: '通过',
      sureRelation: 'hasRejectAndPass',
      sureBtnClickContent: {
        title: '温馨提示',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_pass', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_reject',
        showType: 'dialog-text',
        fnApi: '/api/miApp/auditApproved',
        children: [{
          className: '',
          parentId: '1100-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定审核通过该站点申请？',
          filters: undefined
        }]
      },
      cancelBtnClickContent: {
        title: '拒绝理由',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_tow_fail_sure', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_tow_fail_fail',
        showType: 'dialog-form',
        api: '/api/miApp/auditReject',
        children: [{
          className: '',
          parentId: '1100-tb-1-2',
          label: '',
          id: '1100-tb-1-1',
          key: 'reply', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝理由'
        }]
      }
    },
      {
        permissionId: 87,
        id: '1100-tb-2',
        parentId: '1100',
        type: 'button',
        label: '撤回',
        bLine: true,
        relativeKey: 'hasReturn',
        relativeValue: '1',
        title: '撤回原因',
        fn: 'zdsq_sh_return',
        dialogWidth: '',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/adminWithdraw',
        children: [{
          className: '',
          parentId: '1100-tb-2',
          label: '',
          id: '1100-tb-2-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写撤回原因！'
        }]
      }
    ],
    children: [{
      parentId: '1100',
      name: '审核',
      id: '1100-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '200' // 会跳转到对应到关联页面
    }, {
      parentId: '1100',
      name: '画线',
      id: '1100-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1000' // 会跳转到对应到关联页面
    }, {
      parentId: '1100',
      name: '安装',
      id: '1100-st-3',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '1100' // 会跳转到对应到关联页面
    }, {
      parentId: '1100',
      name: '已拒绝',
      id: '1100-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1200' // 会跳转到对应到关联页面
    }, {
      parentId: '1100',
      name: '不可画线',
      id: '1100-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1300' // 会跳转到对应到关联页面
    }]
  },
  // 站点申请 - 已拒绝
  {
    permissionId: 81,
    name: '站点申请',
    isHide: true,
    showtitle: true,
    relativeId: '200',
    id: '1200',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    defaultPageSize: 100,
    pageSizes: [100, 200, 500],
    total: 0,
    tableData: undefined,
    api: '/api/miApp/getRefuseList',
    tableColumnsName: 'zdsq_jj', // 当前页面 table的取值
    initTranslate: true,
    filters: {
      left: [{
        id: '1200-s-1',
        parentId: '1200',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '勘察组'
          },
          {
            key: 0,
            value: '普通用户'
          }
        ],
        label: '角色：',
        key: 'isInvestigate',
        value: undefined,
        placeholder: ''
      },
        {
          id: '1200-s-3',
          className: 'w120',
          parentId: '1200',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '1',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '申请人：',
          key: 'applyUserId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1200-s-4',
          className: 'w120',
          parentId: '1200',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '2',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '审核人：',
          key: 'checkUserId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1200-s-5',
          parentId: '1200',
          type: 'dataRange',
          label: '申请时间：',
          start: undefined,
          end: undefined,
          key: 'create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1200-s-6',
          parentId: '1200',
          type: 'dataRange',
          label: '审核时间：',
          start: undefined,
          end: undefined,
          key: 'check',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1200-s-7',
          parentId: '1200',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '1200-s-8',
          parentId: '1200',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '1200-s-9',
          parentId: '200',
          type: 'button',
          label: '导出',
          fn: 'rejectExport'
        }
      ],
      right: undefined
    },
    tableButtons: [{
      id: '1200-tb-1',
      parentId: '1200',
      type: 'button',
      label: '查看',
      initDetail: 'zdsq_sh_translate_data',
      fn: 'wgjbShowDetail',
      bLine: false,
      title: '站点申请详情',
      dialogWidth: '55%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '1200-tb-1',
          label: '申请进度',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '进度条',
          key: 'address',
          component: 'steps',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '申请信息',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '位置',
          key: 'address',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '站点长度',
          key: 'length',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '具体描述',
          key: 'memo',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '申请状态',
          key: 'selfStatus',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '照片',
          key: 'showPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '申请人',
          key: 'realname',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '角色',
          key: 'isInvestigate',
          component: 'text',
          value: '',
          filters: 'getInvestigateName'
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '联系方式',
          key: 'phone',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1200-tb-1',
          label: '所属单位',
          key: 'workOrgan',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1200-tb-1',
          label: '画线照片',
          key: 'huaxianPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1200-tb-1',
          label: '安装照片',
          key: 'anzhuangPictures',
          component: 'image',
          value: '',
          filters: undefined
        }
      ],
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '拒绝',
      sureBtnText: '通过',
      sureRelation: 'hasRejectAndPass',
      sureBtnClickContent: {
        title: '温馨提示',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_pass', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_reject',
        showType: 'dialog-text',
        fnApi: '/api/miApp/auditApproved',
        children: [{
          className: '',
          parentId: '1200-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定审核通过该站点申请？',
          filters: undefined
        }]
      },
      cancelBtnClickContent: {
        title: '拒绝理由',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_tow_fail_sure', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_tow_fail_fail',
        showType: 'dialog-form',
        api: '/api/miApp/auditReject',
        children: [{
          className: '',
          parentId: '1200-tb-1-2',
          label: '',
          id: '1200-tb-1-1',
          key: 'reply', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝理由'
        }]
      }
    },
      {
        permissionId: 87,
        id: '1200-tb-2',
        parentId: '1200',
        type: 'button',
        label: '撤回',
        bLine: true,
        relativeKey: 'hasReturn',
        relativeValue: '1',
        title: '撤回原因',
        fn: 'zdsq_sh_return',
        dialogWidth: '',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/adminWithdraw',
        children: [{
          className: '',
          parentId: '1200-tb-2',
          label: '',
          id: '1200-tb-2-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写撤回原因！'
        }]
      }
    ],
    children: [{
      parentId: '1200',
      name: '审核',
      id: '1200-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '200' // 会跳转到对应到关联页面
    }, {
      parentId: '1200',
      name: '画线',
      id: '1200-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1000' // 会跳转到对应到关联页面
    }, {
      parentId: '1200',
      name: '安装',
      id: '1200-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1100' // 会跳转到对应到关联页面
    }, {
      parentId: '1200',
      name: '已拒绝',
      id: '1200-st-4',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '1200' // 会跳转到对应到关联页面
    }, {
      parentId: '1200',
      name: '不可画线',
      id: '1200-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1300' // 会跳转到对应到关联页面
    }]
  },
  // 站点申请 - 不可画线
  {
    permissionId: 82,
    name: '站点申请',
    showtitle: true,
    isHide: true,
    relativeId: '200',
    id: '1300',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    defaultPageSize: 100,
    pageSizes: [100, 200, 500],
    total: 0,
    tableData: undefined,
    api: '/api/miApp/getCanNotDrawList',
    tableColumnsName: 'zdsq_bkhx', // 当前页面 table的取值
    initTranslate: true,
    filters: {
      left: [{
        id: '1300-s-4',
        className: 'w120',
        parentId: '1300',
        apiKey: 'asnyc', // 异步请求
        api: '/api/miApp/fuzzyQueryMaintainList',
        apiParamsKey: 'type',
        apiParamsKeyValue: '2',
        queryStringKey: 'realname', // 用于检索的字段
        valueKey: 'id', // 用户取值的字段
        type: 'autocomplete',
        label: '审核人：',
        key: 'applyUserId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '1300-s-3',
          className: 'w120',
          parentId: '1300',
          apiKey: 'asnyc', // 异步请求
          api: '/api/miApp/fuzzyQueryMaintainList',
          apiParamsKey: 'type',
          apiParamsKeyValue: '3',
          queryStringKey: 'realname', // 用于检索的字段
          valueKey: 'id', // 用户取值的字段
          type: 'autocomplete',
          label: '画线人：',
          key: 'drawerId',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1300-s-5',
          parentId: '1300',
          type: 'dataRange',
          label: '申请时间：',
          start: undefined,
          end: undefined,
          key: 'create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1300-s-6',
          parentId: '1300',
          type: 'dataRange',
          label: '审核时间：',
          start: undefined,
          end: undefined,
          key: 'check',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '1300-s-7',
          parentId: '1300',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '1300-s-8',
          parentId: '1300',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '1300-s-9',
          parentId: '200',
          type: 'button',
          label: '导出',
          fn: 'noLineExport'
        }
      ],
      right: undefined
    },
    tableButtons: [{
      id: '1300-tb-1',
      parentId: '1300',
      type: 'button',
      label: '查看',
      initDetail: 'zdsq_sh_translate_data',
      fn: 'wgjbShowDetail',
      bLine: false,
      title: '站点申请详情',
      dialogWidth: '55%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '1300-tb-1',
          label: '申请进度',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '进度条',
          key: 'address',
          component: 'steps',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '申请信息',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '位置',
          key: 'address',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '站点长度',
          key: 'length',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '具体描述',
          key: 'memo',
          component: 'text',
          value: ''
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '申请状态',
          key: 'selfStatus',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '创建时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '照片',
          key: 'showPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '申请人',
          key: 'realname',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '角色',
          key: 'isInvestigate',
          component: 'text',
          value: '',
          filters: 'getInvestigateName'
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '联系方式',
          key: 'phone',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '1300-tb-1',
          label: '所属单位',
          key: 'workOrgan',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1300-tb-1',
          label: '画线照片',
          key: 'huaxianPictures',
          component: 'image',
          value: '',
          filters: undefined
        }, {
          className: 'mt24',
          parentId: '1300-tb-1',
          label: '安装照片',
          key: 'anzhuangPictures',
          component: 'image',
          value: '',
          filters: undefined
        }
      ],
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '拒绝',
      sureBtnText: '通过',
      sureRelation: 'hasRejectAndPass',
      sureBtnClickContent: {
        title: '温馨提示',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_pass', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_reject',
        showType: 'dialog-text',
        fnApi: '/api/miApp/auditApproved',
        children: [{
          className: '',
          parentId: '1300-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定审核通过该站点申请？',
          filters: undefined
        }]
      },
      cancelBtnClickContent: {
        title: '拒绝理由',
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        fn: 'zdsq_sh_tow_fail_sure', // 违规处理弹窗的确定回复 - 确定
        failFn: 'zdsq_sh_tow_fail_fail',
        showType: 'dialog-form',
        api: '/api/miApp/auditReject',
        children: [{
          className: '',
          parentId: '1300-tb-1-2',
          label: '',
          id: '1300-tb-1-1',
          key: 'reply', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝理由'
        }]
      }
    },
      {
        permissionId: 87,
        id: '1300-tb-2',
        parentId: '1300',
        type: 'button',
        label: '撤回',
        bLine: true,
        relativeKey: 'hasReturn',
        relativeValue: '1',
        title: '撤回原因',
        fn: 'zdsq_sh_return',
        dialogWidth: '',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/adminWithdraw',
        children: [{
          className: '',
          parentId: '1300-tb-2',
          label: '',
          id: '1300-tb-2-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写撤回原因！'
        }]
      }
    ],
    children: [{
      parentId: '1300',
      name: '审核',
      id: '1300-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '200' // 会跳转到对应到关联页面
    }, {
      parentId: '1300',
      name: '画线',
      id: '1300-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1000' // 会跳转到对应到关联页面
    }, {
      parentId: '1300',
      name: '安装',
      id: '1300-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1100' // 会跳转到对应到关联页面
    }, {
      parentId: '1300',
      name: '已拒绝',
      id: '1300-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1200' // 会跳转到对应到关联页面
    }, {
      parentId: '1300',
      name: '不可画线',
      id: '1300-st-5',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '1300' // 会跳转到对应到关联页面
    }]
  },
  // 调度记录
  {
    permissionId: 79,
    name: '调度记录',
    showtitle: true,
    id: '300',
    relativeId: '800',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    pageSizes: [100, 200, 500],
    defaultPageSize: 100,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/miApp/getDispatcherLogList',
    tableColumnsName: 'ddjl', // 当前页面 table的取值
    filters: {
      left: [{
        id: '300-s-1',
        parentId: '300',
        type: 'input',
        label: '车辆编号：',
        key: 'bikeId',
        className: 'w120',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '300-s-2',
          parentId: '300',
          type: 'select',
          options: undefined,
          optionskey: 'brands',
          className: 'w120',
          label: '品牌：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '300-s-3',
          parentId: '300',
          type: 'input',
          label: '起始站点：',
          key: 'startId', // 组件返回的key
          className: 'w120',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '300-s-4',
          parentId: '300',
          type: 'input',
          label: '结束站点：',
          key: 'endId',
          className: 'w120',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '300-s-5',
          parentId: '300',
          type: 'input',
          label: '调度员：',
          key: 'dispatcher',
          className: 'w130',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '300-s-6',
          parentId: '300',
          type: 'data',
          from: '',
          label: '起始时间：',
          key: 'startTime',
          value: undefined,
          defaultTime: '00:00:00',
          placeholder: undefined
        },
        {
          id: '300-s-7',
          parentId: '300',
          type: 'data',
          from: 'end',
          label: '结束时间：',
          key: 'endTime',
          value: undefined,
          defaultTime: '23:59:59',
          placeholder: undefined
        },
        {
          id: '300-s-8',
          parentId: '300',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '300-s-9',
          parentId: '300',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ],
      right: undefined
    },
    children: undefined, // 二级菜单
    ddy: {
      id: '300-tb-1',
      parentId: '300',
      type: 'button',
      label: '运维员',
      fn: 'select',
      bLine: false,
      title: '运维员信息',
      dialogWidth: '60%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '300-tb-1',
          label: '真实姓名',
          key: 'name',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '300-tb-2',
          label: '联系电话',
          key: 'phone',
          component: 'text',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '300-tb-2',
          label: '品牌公司',
          key: 'brandId',
          component: 'text',
          value: '',
          filters: 'filterBrandName'
        }, {
          className: '',
          parentId: '300-tb-2',
          label: '申请时间',
          key: 'createTime',
          component: 'text',
          value: '',
          filters: 'dateFormat'
        }
      ],
      isShowCancelBtn: false,
      isShowSureBtn: false,
      cancelBtnText: '',
      sureBtnText: ''
    }
  },
  // 公告通知
  {
    permissionId: 95,
    name: '公告通知',
    id: '400',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 100,
    defaultPageSize: 100,
    pageSizes: [100, 200, 500],
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/miApp/getNoticeList',
    tableColumnsName: 'ggtz', // 当前页面 table的取值
    filters: {
      left: [{
        id: '400-s-1',
        parentId: '400',
        type: 'dataRange',
        label: '创建时间：',
        start: undefined,
        end: undefined,
        key: 'time',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '400-s-2',
          parentId: '400',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '400-s-3',
          parentId: '400',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ],
      right: [{
        permissionId: 96,
        id: '400-b-1',
        parentId: '400',
        type: 'button',
        label: '新增公告',
        typeStyle: 'primary',
        className: '',
        fn: 'addGgtz',
        title: '发布公告',
        dialogWidth: '60%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '发布',
        api: '/api/miApp/addNotice',
        children: [{
          id: '400-b-1-1',
          className: '',
          parentId: '400-b-1',
          label: '公告标题：',
          key: 'title',
          component: 'input',
          value: undefined
        }, {
          id: '400-b-1-2',
          className: '',
          parentId: '400-b-1',
          label: '公告范围：',
          key: 'area',
          component: 'area',
          value: undefined,
          filters: 'getAreaNames'
        }, {
          id: '400-b-1-3',
          className: '',
          parentId: '400-b-1',
          label: '公告内容：',
          key: 'body',
          component: 'textarea',
          value: undefined,
          rows: '10'
        }]
      }]
    },
    tableButtons: [{
      id: '400-tb-1',
      parentId: '400',
      type: 'button',
      label: '查看',
      fn: 'select',
      bLine: false,
      title: '公告详情',
      dialogWidth: '80%',
      showType: 'dialog-text', // 展示浮层，仅展示内容，根据接口匹配字段
      children: [ // 展示内容明细
        {
          className: '',
          parentId: '400-tb-1',
          label: '',
          key: 'title',
          component: 'title',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '400-tb-1',
          label: '',
          key: 'createTime',
          component: 'gg-info',
          value: '',
          filters: undefined
        }, {
          className: '',
          parentId: '400-tb-1',
          label: '',
          key: 'body',
          component: 'gg-content',
          value: '',
          filters: undefined
        }
      ],
      isShowCancelBtn: false,
      isShowSureBtn: false,
      cancelBtnText: '',
      sureBtnText: ''
    }, {
        permissionId: 249,
        id: '400-tb-2',
        parentId: '400',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'noticeDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '400-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该公告通知？',
          filters: undefined
        }]
      }],
    children: undefined
  },
  // 未传数据车管理匹配成功
  {
    permissionId: 73,
    name: '扫一扫巡查',
    id: '660',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/bikeNotUpload',
    tableColumnsName: 'wccl', // 当前页面 table的取值
    filters: {
      left: [{
        id: '660-s-7',
        parentId: '660',
        type: 'input',
        className: 'w120',
        label: '车辆编码：',
        key: 'bikeId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '660-s-1',
          parentId: '660',
          type: 'select',
          className: 'w120',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '660-s-2',
          parentId: '660',
          type: 'select',
          className: 'w120',
          options: [{
            key: 123,
            value: '全部状态'
          },
            {
              key: 1,
              value: '自动匹配'
            },
            {
              key: 2,
              value: '手动匹配'
            }
          ],
          label: '状态：',
          key: 'matchStatus',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '660-s-3',
          parentId: '660',
          type: 'dataRange',
          label: '入库时间：',
          start: undefined,
          end: undefined,
          key: 'Create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '660-s-4',
          parentId: '660',
          type: 'dataRange',
          label: '最终匹配时间：',
          start: undefined,
          end: undefined,
          key: 'match',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '660-s-5',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '660-s-6',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }, {
          id: '660-b-2',
          parentId: '660',
          type: 'button',
          permissionId: 74,
          label: '批量匹配',
          dialogWidth: '50%',
          fn: 'multmatch',
          title: '批量匹配',
          showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '保存',
          children: [{
            parentId: '660-tb-1',
            key: 'brandId',
            component: 'select',
            options: undefined,
            optionskey: 'brands',
            label: '车企：',
            placeholder: '全部'
          },
            {
              parentId: '660-tb-2',
              key: 'table',
              component: 'table'
            }
          ]
        },
        {
          id: '660-b-1',
          parentId: '660',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          delType: 'bikeNotUpload',
          fn: 'numsDetele',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '660-b-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除车辆？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '660',
      name: '匹配成功',
      id: '660-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '多命中',
      id: '660-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '未命中',
      id: '660-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '巡查日志',
      id: '660-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '巡查统计',
      id: '660-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '二维码地址规则设置',
      id: '660-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '规则设置',
      id: '660-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '660',
      name: '时间设置',
      id: '660-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '660-tb-1',
      type: 'button',
      fn: 'matchAuto', // 保存的方法
      bLine: false,
      showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '660',
      label: '手动匹配',
      title: '手动匹配',
      dialogWidth: '30%',
      children: [ // 展示内容明细
        {
          parentId: '660-tb-1',
          label: '车辆编号',
          key: 'bikeId',
          component: 'text'
        },
        {
          parentId: '660-tb-1',
          label: '操作人',
          key: 'miUserName',
          component: 'text'
        },
        {
          parentId: '660-tb-1',
          label: '入库时间',
          key: 'createTime',
          component: 'text'
        },
        {
          parentId: '660-tb-1',
          label: '自动匹配',
          key: 'brandName',
          component: 'text'
        },
        {
          parentId: '660-tb-1',
          key: 'brandId',
          component: 'select',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          placeholder: '全部'
        }
      ]
    },
      {
        permissionId: 74,
        id: '660-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wcclDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '100-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除“xxx”车辆？',
          filters: undefined,
          sureRelation: 'bikeId'
        }]
      }
    ]
  },
  // 未传数据车管理多命中
  {
    permissionId: 73,
    name: '扫一扫巡查',
    id: '661',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/bikeNotUpload?matchAutoStatus=2',
    tableColumnsName: 'wccl_dmz', // 当前页面 table的取值
    filters: {
      left: [{
        id: '661-s-7',
        parentId: '661',
        type: 'input',
        className: 'w120',
        label: '车辆编码：',
        key: 'bikeId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '661-s-1',
          parentId: '661',
          type: 'select',
          className: 'w120',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '661-s-3',
          parentId: '661',
          type: 'dataRange',
          label: '入库时间：',
          start: undefined,
          end: undefined,
          key: 'Create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '661-s-5',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '661-s-6',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }, {
          id: '661-b-2',
          parentId: '661',
          type: 'button',
          permissionId: 74,
          label: '批量匹配',
          dialogWidth: '50%',
          fn: 'multmatch',
          title: '批量匹配',
          showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '保存',
          children: [{
            parentId: '661-tb-1',
            key: 'brandId',
            component: 'select',
            options: undefined,
            optionskey: 'brands',
            label: '车企：',
            placeholder: '全部'
          },
            {
              parentId: '661-tb-2',
              key: 'table',
              component: 'table'
            }
          ]
        },
        {
          id: '661-b-1',
          parentId: '661',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          delType: 'bikeNotUpload',
          fn: 'numsDetele',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '661-b-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除车辆？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '661',
      name: '匹配成功',
      id: '661-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '多命中',
      id: '661-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '未命中',
      id: '661-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '巡查日志',
      id: '661-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '巡查统计',
      id: '661-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '二维码地址规则设置',
      id: '661-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '规则设置',
      id: '661-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '661',
      name: '时间设置',
      id: '661-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '661-tb-1',
      type: 'button',
      fn: 'matchAuto', // 保存的方法
      bLine: false,
      showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '661',
      label: '手动匹配',
      title: '手动匹配',
      dialogWidth: '50%',
      children: [ // 展示内容明细
        {
          parentId: '661-tb-1',
          label: '车辆编号',
          key: 'bikeId',
          component: 'text'
        },
        {
          parentId: '661-tb-1',
          label: '操作人',
          key: 'miUserName',
          component: 'text'
        },
        {
          parentId: '661-tb-1',
          label: '入库时间',
          key: 'createTime',
          component: 'text'
        },
        {
          parentId: '661-tb-1',
          label: '自动匹配',
          key: 'brandName',
          component: 'text'
        },
        {
          parentId: '661-tb-1',
          key: 'brandId',
          component: 'select',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          placeholder: '全部'
        }
      ]
    },
      {
        permissionId: 74,
        id: '661-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wcclDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '661-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除“xxx”车辆？',
          filters: undefined,
          sureRelation: 'bikeId'
        }]
      }
    ]
  },
  // 未传数据车管理未命中
  {
    permissionId: 73,
    name: '扫一扫巡查',
    id: '662',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/bikeNotUpload?matchAutoStatus=0',
    tableColumnsName: 'wccl_wmz', // 当前页面 table的取值
    filters: {
      left: [{
        id: '662-s-7',
        parentId: '662',
        type: 'input',
        className: 'w120',
        label: '车辆编码：',
        key: 'bikeId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '662-s-3',
          parentId: '662',
          type: 'dataRange',
          label: '入库时间：',
          start: undefined,
          end: undefined,
          key: 'Create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '662-s-5',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '662-s-6',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }, {
          id: '662-b-2',
          parentId: '662',
          type: 'button',
          permissionId: 74,
          label: '批量匹配',
          dialogWidth: '50%',
          fn: 'multmatch',
          title: '批量匹配',
          showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '保存',
          children: [{
            parentId: '662-tb-1',
            key: 'brandId',
            component: 'select',
            options: undefined,
            optionskey: 'brands',
            label: '车企：',
            placeholder: '全部'
          },
            {
              parentId: '662-tb-2',
              key: 'table',
              component: 'table'
            }
          ]
        },
        {
          id: '662-b-1',
          parentId: '662',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          delType: 'bikeNotUpload',
          fn: 'numsDetele',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '662-b-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除车辆？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '662',
      name: '匹配成功',
      id: '662-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '多命中',
      id: '662-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '未命中',
      id: '662-st-3',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '巡查日志',
      id: '662-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '巡查统计',
      id: '662-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '二维码地址规则设置',
      id: '662-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '规则设置',
      id: '662-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '662',
      name: '时间设置',
      id: '662-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '662-tb-1',
      type: 'button',
      fn: 'matchAuto', // 保存的方法
      bLine: false,
      showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '662',
      label: '手动匹配',
      title: '手动匹配',
      dialogWidth: '50%',
      children: [ // 展示内容明细
        {
          parentId: '662-tb-1',
          label: '车辆编号',
          key: 'bikeId',
          component: 'text'
        },
        {
          parentId: '662-tb-1',
          label: '操作人',
          key: 'miUserName',
          component: 'text'
        },
        {
          parentId: '662-tb-1',
          label: '入库时间',
          key: 'createTime',
          component: 'text'
        },
        {
          parentId: '662-tb-1',
          label: '自动匹配',
          key: 'brandName',
          component: 'text'
        },
        {
          parentId: '662-tb-1',
          key: 'brandId',
          component: 'select',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          placeholder: '全部'
        }
      ]
    },
      {
        permissionId: 74,
        id: '662-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wcclDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '662-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除“xxx”车辆？',
          filters: undefined,
          sureRelation: 'bikeId'
        }]
      }
    ]
  },
  // 未传数据车管理巡查日志
  {
    permissionId: 229,
    name: '扫一扫巡查',
    id: '668',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 20, // 每页数量
    pageSizes: [10, 20, 50],
    defaultPageSize: 20, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    api: '/api/miApp/getMiInspectionRecordsList',
    tableColumnsName: 'wccl_xcrz', // 当前页面 table的取值
    filters: {
      left: [{
        id: '668-s-1',
        parentId: '668',
        type: 'input',
        className: 'w150',
        label: '车辆编码：',
        key: 'bikeId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '668-s-3',
          parentId: '668',
          type: 'input',
          className: 'w130',
          label: '巡查人：',
          key: 'inspectionByName',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '668-s-4',
          parentId: '668',
          type: 'select',
          className: 'w130',
          options: undefined,
          optionskey: 'brands',
          label: '品牌名称：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '668-s-5',
          parentId: '668',
          type: 'select',
          className: 'w150',
          options: [{
            key: undefined,
            value: '全部状态'
          },
            {
              key: 1,
              value: '合法车辆'
            },
            {
              key: 2,
              value: '非法车辆'
            },
            {
              key: 3,
              value: '未备案-未传数据'
            },
            {
              key: 4,
              value: '已备案-未传数据'
            },
            {
              key: 6,
              value: '车管所二维码'
            },
            {
              key: 5,
              value: '无效二维码'
            }
          ],
          label: '巡查结果：',
          key: 'inspectionResult',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '668-s-6',
          parentId: '668',
          type: 'select',
          className: 'w130',
          options: [{
            key: undefined,
            value: '全部状态'
          },
            {
              key: 0,
              value: '未命中'
            },
            {
              key: 1,
              value: '匹配成功'
            },
            {
              key: 2,
              value: '多命中'
            }
          ],
          label: '匹配状态：',
          key: 'matchStatus',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '668-s-9',
          parentId: '668',
          type: 'select',
          className: 'w130',
          options: [{
            key: undefined,
            value: '全部状态'
          },
            {
              key: 0,
              value: '正常巡查'
            },
            {
              key: 1,
              value: '仓库巡查'
            }
          ],
          label: '巡查状态：',
          key: 'recycleSwitch',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '668-s-7',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '668-s-8',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ]
    },
    children: [{
      parentId: '668',
      name: '匹配成功',
      id: '668-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '多命中',
      id: '668-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '未命中',
      id: '668-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '巡查日志',
      id: '668-st-6',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '巡查统计',
      id: '668-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '二维码地址规则设置',
      id: '668-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '规则设置',
      id: '668-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '668',
      name: '时间设置',
      id: '668-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }]
  },
  // 未传数据车管理巡查统计
  {
    permissionId: 230,
    name: '扫一扫巡查',
    id: '669',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 20, // 每页数量
    pageSizes: [10, 20, 50],
    defaultPageSize: 20, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    api: '/api/miApp/getSumMiInspectionRecordsData',
    tableColumnsName: 'wccl_xcrz', // 当前页面 table的取值
    filters: {
      left: [{
          id: '669-s-1',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '669-s-2',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ]
    },
    children: [{
      parentId: '669',
      name: '匹配成功',
      id: '669-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '多命中',
      id: '669-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '未命中',
      id: '669-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '巡查日志',
      id: '669-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '巡查统计',
      id: '669-st-7',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '二维码地址规则设置',
      id: '669-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '规则设置',
      id: '669-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '669',
      name: '时间设置',
      id: '669-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }]
  },
  // 扫一扫巡查——二维码地址规则设置
  {
    permissionId: 247,
    name: '扫一扫巡查',
    id: '670',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: false, // 当前表格是否多选
    bPagination: false,
    api: '/api/miApp/getBrandBikeNotUploadPathRuleList',
    tableColumnsName: 'sysxc_dzgz', // 当前页面 table的取值
    filters: {
      right: [{
        permissionId: 246,
        id: '670-b-1',
        parentId: '400',
        type: 'button',
        label: '添加规则',
        fn: 'addRule',
        title: '添加二维码地址规则',
        dialogWidth: '30%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/saveBrandBikeNotUploadPathRule',
        children: [{
          id: '670-b-1-1',
          component: 'select',
          className: 'w200',
          options: undefined,
          optionskey: 'brands',
          label: '品牌名称：',
          key: 'brandId',
          placeholder: '请选择'
        }, {
          id: '670-b-1-2',
          component: 'input',
          className: 'w200',
          label: '自行车码地址：',
          key: 'bikePath',
          value: undefined,
          placeholder: '请输入'
        }, {
          id: '670-b-1-3',
          component: 'input',
          className: 'w200',
          label: '电动车码地址：',
          key: 'bikeEPath',
          value: undefined,
          placeholder: '请输入'
        }]
      }]
    },
    children: [{
      parentId: '670',
      name: '匹配成功',
      id: '670-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '多命中',
      id: '670-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '未命中',
      id: '670-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '巡查日志',
      id: '670-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '巡查统计',
      id: '670-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '二维码地址规则设置',
      id: '670-st-8',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '规则设置',
      id: '670-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '670',
      name: '时间设置',
      id: '670-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '670-tb-1',
      type: 'button',
      fn: 'editRule', // 保存的方法
      bLine: false,
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '670',
      label: '修改规则',
      title: '修改规则',
      dialogWidth: '30%',
      api: '/api/miApp/modifyUser',
      children: [ // 展示内容明细
        {
          id: '670-tb-1-3',
          component: 'input',
          className: 'w200',
          label: '品牌名称：',
          key: 'brandName',
          value: undefined,
          disabled: true,
          placeholder: '请输入'
        }, {
          id: '670-tb-1-1',
          component: 'input',
          className: 'w200',
          label: '自行车码地址：',
          key: 'bikePath',
          value: undefined,
          placeholder: '请输入'
        }, {
          id: '670-tb-1-2',
          component: 'input',
          className: 'w200',
          label: '电动车码地址：',
          key: 'bikeEPath',
          value: undefined,
          placeholder: '请输入'
        }
      ]
    },
      {
        id: '670-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'ruleDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '670-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该规则？',
          filters: undefined,
          sureRelation: 'id'
        }]
      }
    ]
  },
  // 匹配规则设置
  {
    permissionId: 73,
    name: '扫一扫巡查',
    id: '663',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: false, // 当前表格是否多选
    bPagination: false,
    api: '/api/miApp/brandBikeNotUploadRule',
    tableColumnsName: 'ppgz', // 当前页面 table的取值
    filters: {
      right: [{
        permissionId: 96,
        id: '663-b-1',
        parentId: '400',
        type: 'button',
        label: '添加规则',
        fn: 'addRule',
        title: '添加规则',
        dialogWidth: '60%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/brandBikeNotUploadRule',
        children: [{
          id: '663-b-1-1',
          component: 'input',
          className: 'w100p',
          label: '编码前缀：',
          key: 'bikeIdPrefix',
          value: undefined,
          placeholder: '请输入编码前缀'
        }, {
          id: '663-b-1-2',
          component: 'input',
          className: 'w100p',
          label: '编码位数：',
          key: 'bikeIdLength',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '663-b-1-3',
          component: 'select',
          className: 'w100p',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          key: '_brandId',
          placeholder: '请输入'
        }]
      }]
    },
    children: [{
      parentId: '663',
      name: '匹配成功',
      id: '663-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '多命中',
      id: '663-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '未命中',
      id: '663-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '巡查日志',
      id: '663-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '668' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '巡查统计',
      id: '663-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '二维码地址规则设置',
      id: '663-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '规则设置',
      id: '663-st-4',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '663',
      name: '时间设置',
      id: '663-st-5',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '663-tb-1',
      type: 'button',
      fn: 'editRule', // 保存的方法
      bLine: false,
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '662',
      label: '修改规则',
      title: '修改规则',
      dialogWidth: '60%',
      children: [ // 展示内容明细
        {
          id: '663-tb-1-1',
          component: 'input',
          className: 'w100p',
          label: '编码前缀：',
          key: 'bikeIdPrefix',
          value: undefined,
          placeholder: '请输入编码前缀'
        }, {
          id: '663-tb-1-2',
          component: 'input',
          className: 'w100p',
          label: '编码位数：',
          key: 'bikeIdLength',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }
      ]
    },
      {
        id: '663-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'ruleDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '663-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该规则？',
          filters: undefined,
          sureRelation: 'id'
        }]
      }
    ]
  },
  // 时间设置
  {
    permissionId: 73,
    name: '扫一扫巡查',
    id: '664',
    relativeId: '660',
    showtitle: true,
    isHide: true,
    hideTable: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    api: '/api/miApp/areaBikeNotUploadRule',
    filters: {
      left: [{
        id: '664-s-1',
        parentId: '664',
        type: 'input',
        label: '定时清理天数：',
        key: 'clearDay',
        numinput: true,
        className: 'w120',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '664-s-2',
          parentId: '664',
          type: 'input',
          label: '数据可查询天数：',
          key: 'getDay',
          numinput: true,
          className: 'w120',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '664-s-3',
          parentId: '664',
          type: 'button',
          label: '保存',
          typeStyle: 'primary',
          fn: 'save',
          api: '/api/miApp/areaBikeNotUploadRule'
        }
      ]
    },
    children: [{
      parentId: '664',
      name: '匹配成功',
      id: '664-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '660' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '多命中',
      id: '664-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '661' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '未命中',
      id: '664-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '662' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '巡查日志',
      id: '664-st-6',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '666' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '巡查统计',
      id: '664-st-7',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '669' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '二维码地址规则设置',
      id: '664-st-8',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '670' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '规则设置',
      id: '664-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '663' // 会跳转到对应到关联页面
    }, {
      parentId: '664',
      name: '时间设置',
      id: '664-st-5',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '664' // 会跳转到对应到关联页面
    }]
  },
  // 嗅探匹配成功
  {
    permissionId: 73,
    name: '嗅探巡查',
    id: '665',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/bikeNotUploadMac',
    tableColumnsName: 'xt_ppcg', // 当前页面 table的取值
    filters: {
      left: [{
        id: '665-s-8',
        parentId: '665',
        type: 'input',
        className: 'w130',
        label: '车辆MAC：',
        key: 'bikeMac',
        value: undefined,
        placeholder: undefined
      }, {
        id: '665-s-7',
        parentId: '665',
        type: 'input',
        className: 'w130',
        label: '车辆编码：',
        key: 'bikeId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '665-s-1',
          parentId: '665',
          type: 'select',
          className: 'w130',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '665-s-2',
          parentId: '665',
          type: 'select',
          className: 'w130',
          options: [{
            key: 123,
            value: '全部状态'
          },
            {
              key: 1,
              value: '自动匹配'
            },
            {
              key: 2,
              value: '手动匹配'
            }
          ],
          label: '状态：',
          key: 'matchStatus',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '665-s-3',
          parentId: '665',
          type: 'dataRange',
          label: '入库时间：',
          start: undefined,
          end: undefined,
          key: 'Create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '665-s-4',
          parentId: '665',
          type: 'dataRange',
          label: '最终匹配时间：',
          start: undefined,
          end: undefined,
          key: 'match',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '665-s-5',
          parentId: '100',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '665-s-6',
          parentId: '100',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }, {
          id: '665-b-2',
          parentId: '665',
          type: 'button',
          permissionId: 74,
          delType: 'mac',
          label: '批量匹配',
          dialogWidth: '50%',
          fn: 'multmatch',
          title: '批量匹配',
          showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '保存',
          children: [{
            parentId: '665-tb-1',
            key: 'brandId',
            component: 'select',
            options: undefined,
            optionskey: 'brands',
            label: '车企：',
            placeholder: '全部'
          },
            {
              parentId: '665-tb-2',
              key: 'table',
              isBlue: true,
              component: 'table'
            }
          ]
        },
        {
          id: '665-b-1',
          parentId: '665',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          delType: 'bikeNotUploadMac',
          fn: 'numsDetele',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '665-b-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除车辆？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '665',
      name: '匹配成功',
      id: '665-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '665' // 会跳转到对应到关联页面
    }, {
      parentId: '665',
      name: '多命中',
      id: '665-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '666' // 会跳转到对应到关联页面
    }, {
      parentId: '665',
      name: '规则设置',
      id: '665-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '667' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '665-tb-1',
      type: 'button',
      fn: 'matchAuto', // 保存的方法
      bLine: false,
      delType: 'mac',
      showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '665',
      label: '手动匹配',
      title: '手动匹配',
      dialogWidth: '30%',
      children: [ // 展示内容明细
        {
          parentId: '665-tb-1',
          label: '车辆编号',
          key: 'bikeId',
          component: 'text'
        },
        {
          parentId: '665-tb-1',
          label: '操作人',
          key: 'miUserName',
          component: 'text'
        },
        {
          parentId: '665-tb-1',
          label: '入库时间',
          key: 'createTime',
          component: 'text'
        },
        {
          parentId: '665-tb-1',
          label: '广播name',
          key: 'bleName',
          component: 'text'
        }, {
          parentId: '665-tb-1',
          label: '车辆MAC',
          key: 'bikeMac',
          component: 'text'
        }, {
          parentId: '665-tb-1',
          label: 'RSSI值',
          key: 'bleRssi',
          component: 'text'
        },
        {
          parentId: '665-tb-1',
          label: '车企',
          key: 'brandName',
          component: 'text'
        },
        {
          parentId: '665-tb-1',
          key: 'brandId',
          component: 'select',
          options: undefined,
          optionskey: 'brands',
          label: '选择车企：',
          placeholder: '全部'
        }
      ]
    },
      {
        permissionId: 74,
        id: '665-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wcclDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '665-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除“xxx”车辆？',
          filters: undefined,
          sureRelation: 'bikeId'
        }]
      }
    ]
  },
  // 嗅探多命中
  {
    permissionId: 73,
    name: '嗅探巡查',
    id: '666',
    relativeId: '665',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: 1, // 当前页码
    pageSize: 100, // 每页数量
    pageSizes: [100, 200, 500],
    defaultPageSize: 100, // 默认每页数量 用户重置页面数量
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/bikeNotUploadMac?matchAutoStatus=2',
    tableColumnsName: 'xt_dmz', // 当前页面 table的取值
    filters: {
      left: [{
        id: '666-s-8',
        parentId: '666',
        type: 'input',
        className: 'w120',
        label: '车辆MAC：',
        key: 'bikeMac',
        value: undefined,
        placeholder: undefined
      }, {
        id: '666-s-7',
        parentId: '666',
        type: 'input',
        className: 'w120',
        label: '车辆编码：',
        key: 'bikeId',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '666-s-1',
          parentId: '666',
          type: 'select',
          className: 'w120',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '666-s-3',
          parentId: '666',
          type: 'dataRange',
          label: '入库时间：',
          start: undefined,
          end: undefined,
          key: 'Create',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '666-s-5',
          parentId: '666',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '666-s-6',
          parentId: '666',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }, {
          id: '666-b-2',
          parentId: '666',
          type: 'button',
          permissionId: 74,
          label: '批量匹配',
          delType: 'mac',
          dialogWidth: '50%',
          fn: 'multmatch',
          title: '批量匹配',
          showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '保存',
          children: [{
            parentId: '666-tb-1',
            key: 'brandId',
            component: 'select',
            options: undefined,
            optionskey: 'brands',
            label: '车企：',
            placeholder: '全部'
          },
            {
              parentId: '666-tb-2',
              key: 'table',
              isBlue: true,
              component: 'table'
            }
          ]
        },
        {
          id: '666-b-1',
          parentId: '666',
          type: 'button',
          permissionId: 74,
          label: '批量删除',
          delType: 'bikeNotUploadMac',
          fn: 'numsDetele',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '666-b-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量删除车辆？',
            filters: undefined
          }]
        }
      ]
    },
    children: [{
      parentId: '666',
      name: '匹配成功',
      id: '666-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '665' // 会跳转到对应到关联页面
    }, {
      parentId: '666',
      name: '多命中',
      id: '666-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '666' // 会跳转到对应到关联页面
    }, {
      parentId: '666',
      name: '规则设置',
      id: '666-st-4',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '667' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '666-tb-1',
      type: 'button',
      fn: 'matchAuto', // 保存的方法
      bLine: false,
      delType: 'mac',
      showType: 'dialog-text', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '666',
      label: '手动匹配',
      title: '手动匹配',
      dialogWidth: '50%',
      children: [ // 展示内容明细
        {
          parentId: '666-tb-1',
          label: '车辆编号',
          key: 'bikeId',
          component: 'text'
        },
        {
          parentId: '666-tb-1',
          label: '操作人',
          key: 'miUserName',
          component: 'text'
        },
        {
          parentId: '666-tb-1',
          label: '入库时间',
          key: 'createTime',
          component: 'text'
        },
        {
          parentId: '666-tb-1',
          label: '广播name',
          key: 'bleName',
          component: 'text'
        }, {
          parentId: '666-tb-1',
          label: '车辆MAC',
          key: 'bikeMac',
          component: 'text'
        }, {
          parentId: '666-tb-1',
          label: 'RSSI值',
          key: 'bleRssi',
          component: 'text'
        },
        {
          parentId: '666-tb-1',
          label: '车企',
          key: 'brandName',
          component: 'text'
        },
        {
          parentId: '666-tb-1',
          key: 'brandId',
          component: 'select',
          options: undefined,
          optionskey: 'brands',
          label: '选择车企：',
          placeholder: '全部'
        }
      ]
    },
      {
        permissionId: 74,
        id: '666-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'wcclDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '666-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除“xxx”车辆？',
          filters: undefined,
          sureRelation: 'bikeId'
        }]
      }
    ]
  },
  // 设置
  {
    permissionId: 73,
    name: '嗅探巡查',
    id: '667',
    relativeId: '665',
    showtitle: true,
    isHide: true,
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    total: 0, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: false, // 当前表格是否多选
    bPagination: false,
    api: '/api/miApp/brandBikeNotUploadMacRule',
    tableColumnsName: 'xtppgz', // 当前页面 table的取值
    filters: {
      right: [{
        permissionId: 96,
        id: '667-b-1',
        parentId: '400',
        type: 'button',
        label: '添加规则',
        fn: 'addRule',
        title: '添加规则',
        dialogWidth: '60%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        api: '/api/miApp/brandBikeNotUploadMacRule',
        children: [{
          id: '667-b-1-1',
          component: 'input',
          className: 'w100p',
          label: 'name前缀：',
          key: 'namePrefix',
          value: undefined,
          placeholder: '请输入编码前缀'
        }, {
          id: '667-b-1-2',
          component: 'input',
          className: 'w100p',
          label: 'name位数：',
          key: 'nameLength',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '667-b-1-3',
          component: 'input',
          className: 'w100p',
          label: '编号截取位置：',
          key: 'bikeIdExtractStart',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '667-b-1-4',
          component: 'input',
          className: 'w100p',
          label: '截取长度：',
          key: 'bikeIdExtractLength',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '667-b-1-5',
          component: 'select',
          className: 'w100p',
          options: undefined,
          optionskey: 'brands',
          label: '车企：',
          key: '_brandId',
          placeholder: '请输入'
        }]
      }]
    },
    children: [{
      parentId: '667',
      name: '匹配成功',
      id: '667-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '665' // 会跳转到对应到关联页面
    }, {
      parentId: '667',
      name: '多命中',
      id: '667-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '666' // 会跳转到对应到关联页面
    }, {
      parentId: '667',
      name: '规则设置',
      id: '667-st-4',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '667' // 会跳转到对应到关联页面
    }],
    tableButtons: [{
      id: '667-tb-1',
      type: 'button',
      fn: 'editRule', // 保存的方法
      bLine: false,
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      parentId: '662',
      label: '修改规则',
      title: '修改规则',
      dialogWidth: '60%',
      children: [ // 展示内容明细
        {
          id: '667-tb-1-1',
          component: 'input',
          className: 'w100p',
          label: 'name前缀：',
          key: 'namePrefix',
          value: undefined,
          placeholder: '请输入编码前缀'
        }, {
          id: '667-tb-1-2',
          component: 'input',
          className: 'w100p',
          label: 'name位数：',
          key: 'nameLength',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '667-tb-1-3',
          component: 'input',
          className: 'w100p',
          label: '编号截取位置：',
          key: 'bikeIdExtractStart',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }, {
          id: '667-tb-1-4',
          component: 'input',
          className: 'w100p',
          label: '截取长度：',
          key: 'bikeIdExtractLength',
          numinput: true,
          value: undefined,
          placeholder: '请输入数字'
        }
      ]
    },
      {
        id: '667-tb-2',
        parentId: '100',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        fn: 'ruleDel',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '667-tb-1-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除该规则？',
          filters: undefined,
          sureRelation: 'id'
        }]
      }
    ]
  },
  // 角色管理 - 站点角色
  {
    permissionId: 94,
    name: '角色管理',
    id: '500',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/miApp/getMaintainGroupList',
    tableColumnsName: 'jsgl_zdjs', // 当前页面 table的取值
    filters: {
      left: [{
        id: '500-s-1',
        parentId: '500',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '勘察'
          },
          {
            key: 2,
            value: '审核'
          },
          {
            key: 3,
            value: '划线'
          },
          {
            key: 4,
            value: '安装'
          }
        ],
        label: '角色：',
        key: 'roleId',
        value: '',
        placeholder: ''
      },
        {
          id: '500-s-2',
          parentId: '500',
          type: 'input',
          className: 'w120',
          label: '姓名：',
          key: 'name',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '500-s-3',
          parentId: '500',
          type: 'input',
          className: 'w120',
          label: '工作单位：',
          key: 'workOrgan',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '500-s-4',
          parentId: '500',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '500-s-5',
          parentId: '500',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ],
      right: [{
        id: '500-b-1',
        parentId: '500',
        tabChangeId: '600',
        type: 'button',
        typeStyle: 'primary',
        label: '审核列表',
        className: '',
        fn: 'onAuditList',
        relativeId: '600' // 会跳转到对应到关联页面
      }]
    },
    tableButtons: [{
      permissionId: 92,
      id: '500-tb-2',
      parentId: '500',
      type: 'button',
      label: '修改',
      fn: 'reviseRole',
      roleType: '1',
      api: '/api/miApp/modifyUser',
      title: '修改角色',
      dialogWidth: '80%',
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      children: [{
        id: '500-tb-2-1',
        component: 'input',
        className: 'w100p',
        label: '真实姓名：',
        key: 'name',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '500-tb-2-2',
        component: 'input',
        className: 'w100p',
        label: '手机号码：',
        key: 'phone',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '500-tb-2-3',
        component: 'input',
        className: 'w100p',
        label: '工作单位：',
        key: 'workOrgan',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '500-tb-2-4',
        component: 'select',
        className: 'w100p',
        label: '角色类型：',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '勘察'
          },
          {
            key: 2,
            value: '审核'
          },
          {
            key: 3,
            value: '划线'
          },
          {
            key: 4,
            value: '安装'
          }
        ],
        key: 'maintainGroup',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '500-tb-2-5',
        component: 'areaArea',
        label: '适用范围：',
        key: 'area',
        value: undefined,
        placeholder: '地区'
      }]
    },
      {
        permissionId: 92,
        id: '500-tb-1',
        parentId: '500',
        type: 'button',
        title: '温馨提示',
        label: '删除',
        // relativeKey: 'maintainGroup',
        // relativeValue: '1',
        fn: 'jsgl_zdjs_del',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '100-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定删除“xxx”角色？',
          filters: undefined,
          sureRelation: 'name'
        }]
      }
    ],
    children: [{
      parentId: '500',
      name: '站点角色',
      id: '500-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '500' // 会跳转到对应到关联页面
    }, {
      parentId: '500',
      name: '运维员',
      id: '500-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '800' // 会跳转到对应到关联页面
    }, {
      parentId: '500',
      name: '监管员',
      id: '500-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '901' // 会跳转到对应到关联页面
    }]
  },
  // 角色管理-运维员
  {
    permissionId: 93,
    name: '角色管理',
    isHide: true,
    showtitle: true,
    id: '800',
    relativeId: '500', // 关联500的tab展示
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/miApp/getDispatcherList',
    tableColumnsName: 'jsgl_ywy', // 当前页面 table的取值
    filters: {
      left: [{
        id: '800-s-1',
        parentId: '800',
        type: 'input',
        className: 'w120',
        label: '姓名：',
        key: 'name',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '800-s-2',
          parentId: '800',
          type: 'select',
          className: 'w120',
          options: undefined,
          optionskey: 'brands',
          label: '工作单位：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '全部'
        },
        {
          id: '800-s-4',
          parentId: '800',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '800-s-5',
          parentId: '800',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ],
      right: [{
        id: '800-b-1',
        parentId: '800',
        tabChangeId: '600',
        type: 'button',
        typeStyle: 'primary',
        label: '审核列表',
        className: '',
        fn: 'onAuditList'
      }]
    },
    tableButtons: [{
      permissionId: 92,
      id: '800-tb-2',
      parentId: '800',
      type: 'button',
      label: '修改',
      fn: 'reviseRole',
      api: '/api/miApp/modifyUser',
      title: '修改运维员',
      roleType: '2',
      dialogWidth: '50%',
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      children: [{
        id: '800-tb-2-1',
        component: 'input',
        className: 'w100p',
        label: '真实姓名：',
        key: 'name',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '800-tb-2-2',
        component: 'input',
        className: 'w100p',
        label: '手机号码：',
        key: 'phone',
        value: undefined,
        placeholder: '请输入'
      },
        {
          id: '800-tb-2-3',
          component: 'select',
          className: 'w100p',
          options: undefined,
          optionskey: 'brands',
          label: '工作单位：',
          key: 'brandId',
          dValue: '',
          value: '',
          placeholder: '请输入'
        },
        {
          id: '800-tb-2-5',
          component: 'areaArea',
          label: '权限区域：',
          key: 'area',
          value: undefined,
          placeholder: '地区'
        }
      ]
    },
      {
        permissionId: 92,
        id: '800-tb-1',
        parentId: '800',
        type: 'button',
        label: '删除',
        relativeKey: 'dispatchSwitch',
        relativeValue: '1',
        fn: 'jsgl_zdjs_del',
        bLine: true,
        dialogWidth: '',
        title: '温馨提示',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        children: [{
          className: '',
          parentId: '100-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: '你是否确定通过删除“xxx”运维员？',
          filters: undefined,
          sureRelation: 'name'
        }]
      }
    ],
    children: [{
      parentId: '800',
      name: '站点角色',
      id: '800-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '500' // 会跳转到对应到关联页面
    }, {
      parentId: '800',
      name: '运维员',
      id: '800-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '800' // 会跳转到对应到关联页面
    }, {
      parentId: '800',
      name: '监管员',
      id: '800-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '901' // 会跳转到对应到关联页面
    }]
  },
  // 角色管理-监管员
  {
    permissionId: 93,
    name: '角色管理',
    showtitle: true,
    id: '901',
    isHide: true,
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/miApp/getSuperviseList',
    tableColumnsName: 'jsgl_jgy', // 当前页面 table的取值
    filters: {
      left: [{
        id: '901-s-1',
        parentId: '901',
        type: 'input',
        className: 'w120',
        label: '姓名：',
        key: 'name',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '901-s-2',
          parentId: '901',
          type: 'input',
          className: 'w120',
          label: '工作单位：',
          key: 'workOrgan',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '901-s-3',
          parentId: '901',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '901-s-4',
          parentId: '901',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        }
      ],
      right: [{
        id: '901-b-1',
        parentId: '901',
        tabChangeId: '902',
        type: 'button',
        typeStyle: 'primary',
        label: '审核列表',
        className: '',
        fn: 'onAuditList'
      }]
    },
    tableButtons: [{
      permissionId: 92,
      id: '901-tb-2',
      parentId: '901',
      type: 'button',
      label: '修改',
      roleType: '3',
      fn: 'reviseRole',
      api: '/api/miApp/modifyUser',
      title: '修改监管员',
      dialogWidth: '50%',
      showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '保存',
      children: [{
        id: '901-tb-2-1',
        component: 'input',
        className: 'w100p',
        label: '真实姓名：',
        key: 'name',
        value: undefined,
        placeholder: '请输入'
      }, {
        id: '901-tb-2-2',
        component: 'input',
        className: 'w100p',
        label: '手机号码：',
        key: 'phone',
        value: undefined,
        placeholder: '请输入'
      },
        {
          id: '901-tb-2-3',
          component: 'input',
          className: 'w100p',
          label: '工作单位：',
          key: 'workOrgan',
          value: undefined,
          placeholder: '请输入'
        },
        {
          id: '901-tb-2-5',
          component: 'select',
          label: '考勤打卡：',
          options: [
            {
              key: '0',
              value: '不打卡'
            },
            {
              key: '1',
              value: '打卡'
            }
          ],
          key: 'clockStatus',
          value: undefined,
          placeholder: '请选择'
        },
        {
          id: '901-tb-2-4',
          component: 'areaArea',
          label: '权限区域：',
          key: 'area',
          value: undefined,
          placeholder: '地区'
        }
      ]
    },
      {
        permissionId: 92,
        id: '901-tb-1',
        parentId: '901',
        type: 'button',
        label: '删除',
        relativeKey: 'superviseSwitch',
        relativeValue: '1',
        fn: 'jsgl_zdjs_del',
        bLine: true,
        dialogWidth: '',
        showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '确定',
        title: '温馨提示',
        children: [{
          className: '',
          parentId: '901-tb-1',
          label: '',
          key: 'address',
          component: 'statictext',
          value: ' 你是否确定通过删除“xxx”监管员？',
          filters: undefined,
          sureRelation: 'name'
        }]
      }
    ],
    children: [{
      parentId: '901',
      name: '站点角色',
      id: '901-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '500' // 会跳转到对应到关联页面
    }, {
      parentId: '901',
      name: '运维员',
      id: '901-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '800' // 会跳转到对应到关联页面
    }, {
      parentId: '901',
      name: '监管员',
      id: '901-st-3',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '901' // 会跳转到对应到关联页面
    }]
  },
  // 审核列表 - 站点角色
  {
    permissionId: 88,
    name: '审核列表',
    relativeId: '500',
    id: '600',
    isHide: true,
    active: false,
    showtitle: true,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: true, // 当前表格是否多选
    selectInitFn: 'shlb_zdgl_selectInitFn',
    api: '/api/miApp/getMaintainGroupApplyList',
    tableColumnsName: 'shlb_zdgl', // 当前页面 table的取值
    filters: {
      left: [{
        id: '600-s-1',
        parentId: '600',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 1,
            value: '勘察'
          },
          {
            key: 2,
            value: '审核'
          },
          {
            key: 3,
            value: '划线'
          },
          {
            key: 4,
            value: '安装'
          }
        ],
        label: '角色：',
        key: 'roleId',
        value: '',
        placeholder: ''
      },
        {
          id: '600-s-2',
          parentId: '600',
          type: 'select',
          className: 'w120',
          options: [{
            key: undefined,
            value: '全部'
          },
            {
              key: 0,
              value: '处理中'
            },
            {
              key: 1,
              value: '通过'
            },
            {
              key: 2,
              value: '驳回'
            }
          ],
          label: '申请状态：',
          key: 'applyStatus',
          value: '',
          placeholder: ''
        },
        {
          id: '600-s-3',
          parentId: '600',
          type: 'dataRange',
          label: '申请时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '600-s-4',
          parentId: '600',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '600-s-5',
          parentId: '600',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          id: '600-s-6',
          parentId: '600',
          type: 'button',
          label: '批量通过',
          typeStyle: 'primary',
          fn: 'shlb_zdgl_pass',
          piliang: 1,
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '600-s-6-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量通过选中的角色申请？',
            filters: undefined
          }]
        },
        {
          id: '600-s-7',
          parentId: '600',
          type: 'button',
          label: '批量拒绝',
          typeStyle: '',
          fn: 'shlb_zdgl_reject',
          title: '拒绝原因',
          piliang: 1,
          dialogWidth: '80%',
          showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '添加',
          children: [{
            className: '',
            parentId: '600-s-7-2',
            label: '',
            id: '600-s-7-1',
            key: 'reason', // 提交的字段
            component: 'textarea',
            value: '',
            require: true,
            errText: '请填写拒绝原因！'
          }]
        }
      ],
      right: undefined
    },
    tableButtons: [{
      permissionId: 90,
      id: '600-tb-1',
      parentId: '600',
      type: 'button',
      label: '通过',
      relativeKey: 'applyStatus',
      relativeValue: '0',
      fn: 'shlb_zdgl_pass',
      bLine: false,
      dialogWidth: '',
      showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '确定',
      children: [{
        className: '',
        parentId: '600-tb-1-1',
        label: '',
        key: 'address',
        component: 'statictext',
        value: '你是否确定通过"xxx"的角色申请？',
        filters: undefined,
        sureRelation: 'name'
      }]
    },
      {
        permissionId: 91,
        id: '600-tb-2',
        parentId: '600',
        type: 'button',
        relativeKey: 'applyStatus',
        relativeValue: '0',
        label: '拒绝',
        fn: 'shlb_zdgl_reject',
        bLine: true,
        title: '拒绝原因',
        dialogWidth: '80%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        children: [{
          className: '',
          parentId: '600-tb-2',
          label: '',
          id: '600-tb-3-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝原因！'
        }]
      }
    ],
    children: [{
      parentId: '600',
      name: '站点角色',
      id: '600-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '600' // 会跳转到对应到关联页面
    }, {
      parentId: '600',
      name: '运维员',
      id: '600-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '900' // 会跳转到对应到关联页面
    }, {
      parentId: '600',
      name: '监管员',
      id: '600-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '902' // 会跳转到对应到关联页面
    }]
  },
  // 审核列表 - 运维员
  {
    permissionId: 89,
    name: '审核列表',
    relativeId: '800',
    id: '900',
    isHide: true,
    showtitle: true,
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/getDispatcherApplyList',
    tableColumnsName: 'shlb_duy', // 当前页面 table的取值
    filters: {
      left: [{
        id: '900-s-1',
        parentId: '900',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 0,
            value: '处理中'
          },
          {
            key: 1,
            value: '通过'
          },
          {
            key: 2,
            value: '驳回'
          }
        ],
        label: '申请状态：',
        key: 'applyStatus',
        value: undefined,
        placeholder: ''
      },
        {
          id: '900-s-2',
          parentId: '900',
          type: 'dataRange',
          label: '申请时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '900-s-4',
          parentId: '900',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '900-s-5',
          parentId: '900',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          permissionId: 900,
          id: '600-s-6',
          parentId: '600',
          type: 'button',
          label: '批量通过',
          typeStyle: 'primary',
          fn: 'shlb_zdgl_pass',
          piliang: 1,
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '600-s-6-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量通过选中的运维员申请？',
            filters: undefined
          }]
        },
        {
          permissionId: 911,
          id: '600-s-7',
          parentId: '600',
          type: 'button',
          label: '批量拒绝',
          typeStyle: '',
          fn: 'shlb_zdgl_reject',
          title: '拒绝原因',
          piliang: 1,
          dialogWidth: '50%',
          showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '添加',
          children: [{
            className: '',
            parentId: '600-s-7-2',
            label: '',
            id: '600-s-7-1',
            key: 'reason', // 提交的字段
            component: 'textarea',
            value: '',
            require: true,
            errText: '请填写拒绝原因！'
          }]
        }
      ],
      right: undefined
    },
    tableButtons: [{
      permissionId: 90,
      id: '600-tb-1',
      parentId: '600',
      type: 'button',
      label: '通过',
      relativeKey: 'applyStatus',
      relativeValue: '0',
      fn: 'shlb_zdgl_pass',
      bLine: false,
      dialogWidth: '',
      showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '确定',
      children: [{
        className: '',
        parentId: '600-tb-1-1',
        label: '',
        key: 'address',
        component: 'statictext',
        value: '你是否确定通过“xxx”的运维员申请？',
        filters: undefined,
        sureRelation: 'name'
      }]
    },
      {
        permissionId: 91,
        id: '600-tb-2',
        parentId: '600',
        type: 'button',
        relativeKey: 'applyStatus',
        relativeValue: '0',
        label: '拒绝',
        fn: 'shlb_zdgl_reject',
        bLine: true,
        title: '拒绝原因',
        dialogWidth: '50%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        children: [{
          className: '',
          parentId: '600-tb-2',
          label: '',
          id: '600-tb-3-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝原因！'
        }]
      }
    ],
    children: [{
      parentId: '900',
      name: '站点角色',
      id: '900-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '600' // 会跳转到对应到关联页面
    }, {
      parentId: '900',
      name: '运维员',
      id: '900-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '900' // 会跳转到对应到关联页面
    }, {
      parentId: '900',
      name: '监管员',
      id: '900-st-3',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '902' // 会跳转到对应到关联页面
    }]
  },
  // 审核列表 - 监管员
  {
    permissionId: 89,
    name: '审核列表',
    relativeId: '901',
    id: '902',
    showtitle: true,
    isHide: true,
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: true, // 当前表格是否多选
    api: '/api/miApp/getSuperviseApplyList',
    tableColumnsName: 'shlb_jgy', // 当前页面 table的取值
    filters: {
      left: [{
        id: '902-s-1',
        parentId: '902',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        },
          {
            key: 0,
            value: '处理中'
          },
          {
            key: 1,
            value: '通过'
          },
          {
            key: 2,
            value: '驳回'
          }
        ],
        label: '申请状态：',
        key: 'applyStatus',
        value: undefined,
        placeholder: ''
      },
        {
          id: '902-s-2',
          parentId: '902',
          type: 'dataRange',
          label: '申请时间：',
          start: undefined,
          end: undefined,
          key: 'time',
          value: undefined,
          placeholder: undefined
        },
        {
          id: '902-s-4',
          parentId: '902',
          type: 'button',
          label: '查询',
          typeStyle: 'primary',
          fn: 'search'
        },
        {
          id: '902-s-5',
          parentId: '902',
          type: 'button',
          label: '重置',
          typeStyle: '',
          fn: 'reset'
        },
        {
          permissionId: 902,
          id: '600-s-6',
          parentId: '600',
          type: 'button',
          label: '批量通过',
          typeStyle: 'primary',
          fn: 'shlb_zdgl_pass',
          piliang: 1,
          dialogWidth: '',
          title: '温馨提示',
          showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '确定',
          children: [{
            className: '',
            parentId: '600-s-6-1',
            label: '',
            key: 'address',
            component: 'statictext',
            value: '你是否确定批量通过选中的监管员申请？',
            filters: undefined
          }]
        },
        {
          permissionId: 911,
          id: '600-s-7',
          parentId: '600',
          type: 'button',
          label: '批量拒绝',
          typeStyle: '',
          fn: 'shlb_zdgl_reject',
          title: '拒绝原因',
          piliang: 1,
          dialogWidth: '50%',
          showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
          isShowCancelBtn: true,
          isShowSureBtn: true,
          cancelBtnText: '取消',
          sureBtnText: '添加',
          children: [{
            className: '',
            parentId: '600-s-7-2',
            label: '',
            id: '600-s-7-1',
            key: 'reason', // 提交的字段
            component: 'textarea',
            value: '',
            require: true,
            errText: '请填写拒绝原因！'
          }]
        }
      ],
      right: undefined
    },
    tableButtons: [{
      permissionId: 90,
      id: '600-tb-1',
      parentId: '600',
      type: 'button',
      label: '通过',
      relativeKey: 'applyStatus',
      relativeValue: '0',
      fn: 'shlb_zdgl_pass',
      bLine: false,
      dialogWidth: '',
      showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '确定',
      children: [{
        className: '',
        parentId: '600-tb-1-1',
        label: '',
        key: 'address',
        component: 'statictext',
        value: '你是否确定通过“xxx”的监管员申请？',
        filters: undefined,
        sureRelation: 'name'
      }]
    },
      {
        permissionId: 91,
        id: '600-tb-2',
        parentId: '600',
        type: 'button',
        relativeKey: 'applyStatus',
        relativeValue: '0',
        label: '拒绝',
        fn: 'shlb_zdgl_reject',
        bLine: true,
        title: '拒绝原因',
        dialogWidth: '50%',
        showType: 'dialog-form', // 展示浮层，仅展示内容，静态文案
        isShowCancelBtn: true,
        isShowSureBtn: true,
        cancelBtnText: '取消',
        sureBtnText: '添加',
        children: [{
          className: '',
          parentId: '600-tb-2',
          label: '',
          id: '600-tb-3-1',
          key: 'reason', // 提交的字段
          component: 'textarea',
          value: '',
          require: true,
          errText: '请填写拒绝原因！'
        }]
      }
    ],
    children: [{
      parentId: '902',
      name: '站点角色',
      id: '902-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '600' // 会跳转到对应到关联页面
    }, {
      parentId: '902',
      name: '运维员',
      id: '902-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '900' // 会跳转到对应到关联页面
    }, {
      parentId: '902',
      name: '监管员',
      id: '902-st-3',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '902' // 会跳转到对应到关联页面
    }]
  },
  {
    permissionId: 89,
    name: '设置',
    relativeId: '903',
    id: '903',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 20,
    defaultPageSize: 20,
    pageSizes: [20, 50, 100],
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/clock/getClockSiteList',
    tableColumnsName: 'clockSiteList', // 当前页面 table的取值
    filters: {
      left: [{
        id: '903-s-1',
        parentId: '903',
        type: 'input',
        label: '违规处理响应时间设置：',
        key: 'time',
        numinput: true,
        className: 'w120',
        value: undefined,
        placeholder: undefined
      },
        {
          id: '903-s-2',
          parentId: '903',
          type: 'button',
          label: '保存',
          typeStyle: 'primary',
          fn: 'save',
          api: '/api/miApp/setViolationTime'
        }
      ]
    },
    tableButtons: [{
      id: '903-tb-1',
      parentId: '903',
      type: 'button',
      label: '修改',
      fn: 'updateClockSite',
      bLine: false
    }, {
      id: '903-tb-2',
      parentId: '903',
      type: 'button',
      title: '温馨提示',
      label: '删除',
      fn: 'delClockSite',
      bLine: true,
      dialogWidth: '',
      showType: 'dialog-text2', // 展示浮层，仅展示内容，静态文案
      isShowCancelBtn: true,
      isShowSureBtn: true,
      cancelBtnText: '取消',
      sureBtnText: '确定',
      children: [{
        className: '',
        parentId: '903-tb-1',
        label: '',
        key: 'address',
        component: 'statictext',
        value: '你是否确定删除【xxx】考勤站点？',
        filters: undefined,
        sureRelation: 'clockSiteName'
      }]
    }],
    children: undefined
  },
  // 考勤统计-日统计
  {
    permissionId: 92,
    name: '考勤统计',
    id: '1001',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 10,
    defaultPageSize: 10,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/clockRecord/getClockStatisticsDayCollect',
    tableColumnsName: 'clock_statistics_day', // 当前页面 table的取值
    filters: {
      left: [{
        id: '1001-s-2',
        parentId: '1001',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      }, {
        id: '1001-s-3',
        parentId: '1001',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        }, {
          key: 1,
          value: '已打卡'
        }, {
          key: 2,
          value: '缺卡'
        }
        ],
        label: '考勤类型：',
        key: 'dateType',
        value: undefined,
        placeholder: ''
      }, {
        id: '1001-s-7',
        parentId: '1001',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        }, {
          key: 1,
          value: '运维员'
        }, {
          key: 2,
          value: '监管员'
        }
        ],
        label: '角色类型：',
        key: 'clockRole',
        value: undefined,
        placeholder: ''
      }, {
        id: '1001-s-5',
        parentId: '1001',
        type: 'button',
        label: '查询',
        typeStyle: 'primary',
        fn: 'search'
      }, {
        id: '1001-s-6',
        parentId: '1001',
        type: 'button',
        label: '重置',
        typeStyle: '',
        fn: 'reset'
      }
      ]
    },
    tableButtons: [{
      id: '1001-tb-1',
      parentId: '1001',
      type: 'button',
      label: '详细',
      fn: 'checkClockStatisticsDay',
      bLine: false
    }],
    children: [{
      parentId: '1001',
      name: '日统计',
      id: '1001-st-1',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '1001' // 会跳转到对应到关联页面
    }, {
      parentId: '1001',
      name: '月统计',
      id: '1001-st-2',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1002' // 会跳转到对应到关联页面
    }]
  },
  // 考勤统计-月统计
  {
    permissionId: 92,
    name: '月统计',
    isHide: true,
    showtitle: true,
    id: '1002',
    relativeId: '1001', // 关联1001的tab展示
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 10,
    defaultPageSize: 10,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/clockRecord/getClockStatisticsMonthList',
    tableColumnsName: 'clock_statistics_month', // 当前页面 table的取值
    filters: {
      left: [{
        id: '1002-s-1',
        parentId: '1002',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      }, {
        id: '1002-s-2',
        parentId: '1002',
        type: 'select',
        className: 'w120',
        options: [{
          key: '',
          value: '全部'
        }, {
          key: 1,
          value: '平均工时'
        }, {
          key: 2,
          value: '打卡人数'
        }, {
          key: 3,
          value: '缺卡'
        }
        ],
        label: '考勤类型：',
        key: 'monthType',
        value: '',
        placeholder: ''
      }, {
        id: '1002-s-3',
        parentId: '1002',
        type: 'input',
        className: 'w120',
        label: '姓名：',
        key: 'name',
        value: undefined,
        placeholder: undefined
      }, {
        id: '1002-s-6',
        parentId: '1002',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        }, {
          key: 1,
          value: '运维员'
        }, {
          key: 2,
          value: '监管员'
        }
        ],
        label: '角色类型：',
        key: 'clockRole',
        value: undefined,
        placeholder: ''
      }, {
        id: '1002-s-4',
        parentId: '1002',
        type: 'button',
        label: '查询',
        typeStyle: 'primary',
        fn: 'search'
      }, {
        id: '1002-s-5',
        parentId: '1002',
        type: 'button',
        label: '重置',
        typeStyle: '',
        fn: 'reset'
      }
      ]
    },
    children: [{
      parentId: '1002',
      name: '日统计',
      id: '1002-st-1',
      active: false,
      cached: false,
      state: undefined,
      relativeId: '1001' // 会跳转到对应到关联页面
    }, {
      parentId: '1002',
      name: '月统计',
      id: '1002-st-2',
      active: true,
      cached: false,
      state: undefined,
      relativeId: '1002' // 会跳转到对应到关联页面
    }]
  },
  // 轨迹回放
  {
    permissionId: 92,
    name: '轨迹回放',
    id: '1003',
    active: false,
    cached: false,
    state: undefined,
    pageNum: 1,
    pageSize: 10,
    defaultPageSize: 20,
    total: 0,
    tableData: undefined,
    needSelection: false, // 当前表格是否多选
    api: '/api/miApp/getClockTrackList',
    tableColumnsName: 'track_play_back', // 当前页面 table的取值
    filters: {
      left: [{
        id: '1003-s-1',
        parentId: '1003',
        type: 'data',
        className: 'w120',
        from: '',
        label: '日期：',
        key: 'dateFormat',
        value: undefined,
        defaultTime: '00:00:00',
        placeholder: undefined
      }, {
        id: '1003-s-2',
        parentId: '1003',
        type: 'select',
        className: 'w120',
        options: undefined,
        optionskey: 'brands',
        label: '品牌：',
        key: 'brandId',
        dValue: '',
        value: '',
        placeholder: '全部'
      }, {
        id: '1003-s-3',
        parentId: '1003',
        type: 'input',
        className: 'w120',
        label: '姓名：',
        key: 'name',
        value: undefined,
        placeholder: undefined
      }, {
        id: '1003-s-6',
        parentId: '1001',
        type: 'select',
        className: 'w120',
        options: [{
          key: undefined,
          value: '全部'
        }, {
          key: 1,
          value: '运维员'
        }, {
          key: 2,
          value: '监管员'
        }
        ],
        label: '角色类型：',
        key: 'clockRole',
        value: undefined,
        placeholder: ''
      }, {
        id: '1003-s-4',
        parentId: '1001',
        type: 'button',
        label: '查询',
        typeStyle: 'primary',
        fn: 'search'
      }, {
        id: '1003-s-5',
        parentId: '1001',
        type: 'button',
        label: '重置',
        typeStyle: '',
        fn: 'reset'
      }
      ]
    },
    tableButtons: [{
      id: '1003-tb-1',
      parentId: '1003',
      type: 'button',
      label: '查看',
      fn: 'checkClockTrack',
      bLine: false
    }]
  }
]

export default config
